import { storage } from './storage';
import { deepAssign } from './index';

// 跨域项目合集
const ichubProjectList = [
  { domain: 'store', prefix: 'store', name: 'web2.0', desc: 'web2.0项目，包括供求、人脉、服务等' },
  { domain: 'content', prefix: 'content', name: '内容域', desc: '内容域项目' },
  { domain: 'seo', prefix: 'srvContent', name: 'seo', desc: 'seo项目' },
  { domain: 'contract', prefix: 'contract', name: '合约域', desc: '合约域项目' }
];
const ichubProjectData = (domain) => {
  const findProject = ichubProjectList.find((item) => item.domain === domain) || {};
  return { ...findProject };
};
const companyTypes = {
  arr:[
    {id:'llc', name:'有限责任公司'},
    {id:'stock', name:'股份公司'},
    {id:'individual', name:'个人独资企业'},
    {id:'partnership', name:'合伙企业'},
    {id:'soe', name:'国有企业'},
    {id:'foreign_invested', name:'外商投资企业'},
    {id:'private', name:'私营企业'},
    {id:'individual_industrial', name:'个体工商户'},
    {id:'farmer_professional', name:'农民专业合作社'},
    {id:'collective_owned', name:'集体所有制企业'},
  ]
}
const livingState = {
  arr: [
    {id:'continuance',name:'存续'},
    {id:'in_operation ',name:'在业'},
    {id:'revocation',name:'吊销'},
    {id:'cancellation',name:'注销'},
    {id:'move_in',name:'迁入'},
    {id:'move_out',name:'迁出'},
    {id:'suspension',name:'停业'},
    {id:'liquidation',name:'清算'},
  ]
}
// 合约域协议类型
const agreementType = {
  arr: [
    { id: 1, name: '用户' },
    { id: 2, name: '主体' },
    { id: 3, name: '员工' },
    { id: 4, name: '毛利' },
    { id: 5, name: '经销商' },
    { id: 6, name: '服务商' },
    { id: 7, name: '银行' },
    { id: 8, name: '垫付' },
    { id: 9, name: '物流' },
    { id: 10, name: '财务' },
    { id: 11, name: '品控' },
    { id: 12, name: '报关' },
    { id: 13, name: '媒体' },
    { id: 14, name: '人资' },
    { id: 15, name: '法务' },
    { id: 16, name: '保险' },
    { id: 17, name: '数据' },
  ],
  json: {
    1: '用户',
    2: '主体',
    3: '员工',
    4: '毛利',
    5: '经销商',
    6: '服务商',
    7: '银行',
    8: '垫付',
    9: '物流',
    10: '财务',
    11: '品控',
    12: '报关',
    13: '媒体',
    14: '人资',
    15: '法务',
    16: '保险',
    17: '数据'
  }
}
// 合约域支付方式
const payType = {//自营记账（资产ICP/信用credit/组合mix）
  arr: [
    { id: 'ICP', name: 'portal.ji-zhang-zhi-fu' },
    { id: 'credit', name: 'portal.ji-zhang-zhi-fu' },
    { id: 'mix', name: 'portal.ji-zhang-zhi-fu' },
    { id: 'wechat', name: 'portal.wei-xin' },
    { id: 'alipay', name: 'portal.zhi-fu-bao' },
    { id: 'hxb', name: '银行转账' },
    // { id: 'transfer', name: '银行汇款' },
    { id: 'IOU', name: '垫付支付' },
    { id: 'yeepay', name: '易宝（二维码）' },
    { id: 'yeepayBankTransfer', name: '易宝（转账）' },
    { id: 'yeepayCashier', name: '易宝（网银）' },
  ],
  json: {
    ICP: 'portal.zi-chan',
    credit: 'portal.xin-yong',
    mix: '组合',
    wechat: 'portal.wei-xin',
    alipay: 'portal.zhi-fu-bao',
    hxb: 'portal.hua-xia-yin-hang',
    transfer: '银行转账',
    IOU: '白条',
    yeepay:'易宝（二维码）',
    yeepayBankTransfer: '易宝（转账）',
    yeepayCashier: '易宝（网银）'
  },
  search:[
    { id: 'accounting_payment', name: 'portal.ji-zhang-zhi-fu' },
    { id: 'guarantee_payment', name: '银行转账' },
    { id: 'advance_payment', name: '垫付支付' },
    // { id: 'bank_transfer', name: '银行汇款' },
    { id: 'wechat', name: 'portal.wei-xin' },
    { id: 'alipay', name: 'portal.zhi-fu-bao' },
    { id: 'yeepay', name: '易宝（二维码）' },
    { id: 'yeepayBankTransfer', name: '易宝（转账）' },
    { id: 'yeepayCashier', name: '易宝（网银）' },
  ]
};
//业务类型
const busySome = {
  arr: [
    { id: 'rfq_line', name: '询价', type: 'RfqLineDetail' },
    { id: 'qfr_line', name: 'portal.bao-jia', type: 'QfrLineDetail' },
    { id: 'sales_order_line', name: '销售', type: 'SalesOrderLineDetail' },
    { id: 'avab_line', name: '供货', type: 'AvabLineDetail' },
    { id: 'qfa_line', name: 'portal.xun-gong', type: 'QfaLineDetail' },
    { id: 'purchase_order_line', name: '采购', type: 'PurchaseOrderLineDetail' }
  ],
  json: {
    rfq_line: '询价',
    qfr_line: 'portal.bao-jia',
    sales_order_line: '销售',
    avab_line: '供货',
    qfa_line: 'portal.xun-gong',
    purchase_order_line: '采购',
  }
}
const busySome2 = {
  arr: [
    { id: 'rfq_line', name: '询价'},
    { id: 'qfr_line', name: 'portal.bao-jia' },
    { id: 'sales_order_line', name: 'portal.buy-pan'},
    { id: 'avab_line', name: '供货'},
    { id: 'qfa_line', name: 'portal.xun-gong'},
    { id: 'purchase_order_line', name: 'portal.mai-pan' },
    { id: 'deal_line', name: '成交' },
  ],
  json: {
    rfq_line: '询价',
    qfr_line: 'portal.bao-jia',
    sales_order_line: 'portal.buy-pan',
    avab_line: '供货',
    qfa_line: 'portal.xun-gong',
    purchase_order_line: 'portal.mai-pan',
    deal_line:'成交'
  }
}
const orderTypeAndPan = {
  arr: [
    { id: 'rfq_line_pan', name: 'portal.xun-pan'},
    { id: 'rfq_line', name: '询价'},
    { id: 'sales_order_line_pan', name: 'portal.buy-pan'},
    { id: 'sales_order_line', name: '销售'},
    { id: 'avab_line_pan', name: 'portal.gong-pan'},
    { id: 'avab_line', name: '供货'},
    { id: 'purchase_order_line_pan', name: 'portal.mai-pan' },
    { id: 'purchase_order_line', name: '采购' },
  ],
  json: {
    rfq_line_pan: 'portal.xun-pan',
    rfq_line: '询价',
    sales_order_line_pan: 'portal.buy-pan',
    sales_order_line: '销售',
    avab_line_pan: 'portal.gong-pan',
    avab_line: '供货',
    purchase_order_line_pan: 'portal.mai-pan',
    purchase_order_line: '采购',
  }
}
//供求类型
const qaType = [
  { id: 'rfq_line', name: '询价', type: 'RfqLineDetail' },
  /*{ id: "qfr_line", name: "报价",type: "QfrLineDetail" },*/
  { id: 'sales_order_line', name: 'portal.buy-pan', type: 'SalesOrderLineDetail' },
  { id: 'avab_line', name: '供货', type: 'AvabLineDetail' },
  /*{ id: "qfa_line", name: "询供", type: "QfaLineDetail" },*/
  { id: 'purchase_order_line', name: 'portal.mai-pan', type: 'PurchaseOrderLineDetail' },
  { id: 'inactive_avab_line', name: 'portal.can-kao', },
];

//价格政策额类型
const ruleType = [
  {
    id: 'Purchasing',
    name: '采购'
  },
  {
    id: 'Sales',
    name: '销售'
  },
  {
    id: 'Product',
    name: '产品'
  },
  {
    id: 'Accounting',
    name: '财务'
  },
  {
    id: 'Logistic',
    name: '物流'
  },
  {
    id: 'Marketing',
    name: '市场'
  },
  {
    id: 'Commission',
    name: '佣金'
  },
  {
    id: 'Data',
    name: '数据'
  }
];
//价格类型
const priceType = [
  {
    id: 'stock',
    name: '现货'
  },
  {
    id: 'future',
    name: '期货'
  },
  {
    id: 'userd stock',
    name: '旧货'
  },
  {
    id: 'unknown',
    name: '其他'
  }
];
const stateTypeNew = [
  { id: 'L', name: 'L' },
  { id: 'E', name: 'E' },
  { id: 'A', name: 'A' },
  { id: 'D', name: 'D' }
];
//状态
const stateType = [
  {
    id: 'L',
    name: 'portal.chu-shi'
  },
  {
    id: 'E',
    name: 'portal.lian-xi'
  },
  {
    id: 'A',
    name: 'portal.jiao-fu'
  },
  {
    id: 'D',
    name: 'portal.wan-cheng'
  }
];
const approvalLetter = {
  draft: 'P',
  submit: 'S',
  return: 'R',
  cancel: 'C',
  confirm: 'A'
};
// 数据类型 映射用到
const dataType = [
  {
    id: '询价',
    name: '询价'
  },
  {
    id: '供货',
    name: '供货'
  },
  {
    id: '报价',
    name: '报价'
  },
  {
    id: '订单',
    name: '订单'
  },
  {
    id: '产品',
    name: '产品'
  },
  {
    id: '物流',
    name: '物流'
  },
  {
    id: '收付款',
    name: '收付款'
  }
];
// 数据类型 interchange_type 映射用到
const interchangeType = {
  arr: [
    {
      id: 'biz_line',
      name: '询价'
    },
    {
      id: 'avab_line',
      name: '供货'
    },
    {
      id: 'qfr_line',
      name: '报价'
    },
    {
      id: 'product',
      name: '产品'
    }
  ],
  json: {
    biz_line: '询价',
    avab_line: '供货',
    qfr_line: '报价',
    product: '产品'
  }
};
//开票条件
const invoice_term = {
  arr: [
    { id: '1', name: '先票后款' },
    { id: '2', name: '先款后票' }
  ],
  json: {
    1: '先票后款',
    2: '先款后票'
  }
};
//交互对象
const hostType = {
  arr: [
    {
      id: 'website',
      name: '网页'
    },
    {
      id: 'api',
      name: 'API'
    },
    {
      id: 'platform',
      name: '平台'
    },
    {
      id: 'ftp',
      name: 'FTP'
    }
  ],
  json: {
    website: '网页',
    api: 'API',
    platform: '平台',
    ftp: 'FTP'
  }
};
//交互类型
const mappingType = {
  arr: [
    {
      id: 'site',
      name: '站点'
    },
    {
      id: 'platform',
      name: '平台'
    }
  ],
  json: {
    site: '站点',
    platform: '平台'
  }
};
const approveType = {
  arr: [
    { id: '初始', name: 'P' },
    { id: '变更', name: 'C' },
    { id: '提交', name: 'S' },
    { id: '退回', name: 'R' },
    { id: '账户批准', name: 'A' },
    { id: '暂停', name: 'D' }
  ],
  cn: [
    { id: 'P', name: 'portal.chu-shi' },
    { id: 'C', name: 'portal.che-xiao' },
    { id: 'S', name: 'portal.ti-jiao' },
    { id: 'R', name: 'portal.tui-hui' },
    { id: 'A', name: 'portal.pi-zhun' },
    { id: 'D', name: 'portal.zan-ting' }
  ],
  json: {
    初始: 'P',
    变更: 'C',
    提交: 'S',
    退回: 'R',
    暂停: 'D',
    账户批准: 'A'
  }
};
const approveTypeEN = {
  arr: [
    { id: 'P', name: 'P' },
    { id: 'S', name: 'S' },
    { id: 'A', name: 'A' },
    { id: 'C', name: 'C' },
    { id: 'D', name: 'D' },
    { id: 'R', name: 'R' }
  ],
  json: {
    初始: 'P',
    变更: 'C',
    提交: 'S',
    退回: 'R',
    暂停: 'D',
    账户批准: 'A'
  }
};
const link_type = {
  arr: [
    {
      id: 'member',
      name: '下单人'
    },
    {
      id: 'contacts',
      name: '联系人'
    }
  ],
  json: {
    member: '下单人',
    contacts: '联系人'
  }
};
const link_type_new = {
  arr: [
    {
      id: 'member',
      name: '下单人'
    },
    {
      id: 'contacts',
      name: '联系人'
    },
    {
      id: 'portal',
      name: '外部'
    }
  ],
  json: {
    member: '下单人',
    contacts: '联系人',
    portal: '外部'
  }
};
const link_contact = {
  arr: [
    {
      id: 'P',
      name: '下单'
    },
    {
      id: 'F',
      name: '财务'
    },
    {
      id: 'L',
      name: '物流'
    },
    {
      id: 'B',
      name: '业务'
    }
  ],
  json: {
    P: '下单',
    F: '财务',
    L: '物流',
    B: '业务'
  }
};
// 地址类型
const address_type = {
  arr: [
    { id: '1', name: 'portal.ban-gong' },
    { id: '2', name: 'portal.wu-liu' },
    { id: '3', name: 'portal.cai-wu' },
    { id: '4', name: 'portal.zhu-jia' }
  ],
  newArr: [
    { id: '1', name: 'portal.ban-gong' },
    { id: '2', name: 'portal.cang-ku' },
    { id: '3', name: 'portal.shou-piao' },
    //{ id: '4', name: '住家' }
  ],
  json: {
    1: 'portal.ban-gong',
    2: 'portal.wu-liu',
    3: 'portal.cai-wu',
    4: 'portal.zhu-jia'
  }
};
//单据业务阶段
const orderBusinessStatus = {
  arr: [
    {
      id: 'draft',
      name: '初始'
    },
    {
      id: 'waiting_br_confirm',
      name: '提交'
    },
    {
      id: 'return',
      name: '退回'
    },
    {
      id: 'waiting_pm_confirm',
      name: '业批'
    },
    {
      id: 'tracking',
      name: '产批'
    },
    {
      id: 'done',
      name: '完成'
    }
  ],
  json: {
    draft: '初始',
    waiting_br_confirm: '提交',
    return: '退回',
    waiting_pm_confirm: '业批',
    tracking: '产批',
    done: '完成'
  }
};
//经销方式
const sales_types = {
  json: {
    manufacturer: '原厂',
    agent: '原厂分销',
    franchised: '代理分销',
    distributor: '经销'
  },
  arr: [
    { id: 'manufacturer', name: '原厂' },
    { id: 'agent', name: '原厂分销' },
    { id: 'franchised', name: '代理分销' },
    { id: 'distributor', name: '经销' }
  ]
};
const salesSource = {
  json: {
    direct: '直销',
    distributor: '代理',
    broker: '贸易'
  },
  arr: [
    { id: 'direct', name: '直销' },
    { id: 'distributor', name: '代理' },
    { id: 'broker', name: '贸易' }
  ]
};
//注册
const registrationTypes = {
  arr: [
    {
      id: 'shop',
      name: '商户'
    },
    {
      id: 'shop_member',
      name: '成员'
    },
    {
      id: 'user',
      name: '用户'
    },
    {
      id: 'shop_contact',
      name: '联系人'
    },
    {
      id: 'shop_member_contact',
      name: '联系人'
    },
    {
      id: 'user_contact',
      name: '联系人'
    },
    {
      id: 'contact',
      name: '联系人'
    }
  ]
};
//联系人类型
const contactTypes = {
  arr: [
    {
      id: 'shop',
      name: '商户'
    },
    {
      id: 'shop_member',
      name: '成员'
    },
    {
      id: 'shop_contact',
      name: '联系人'
    },
    {
      id: 'shop_member_contact',
      name: '联系人'
    },
    {
      id: 'contact',
      name: '联系人'
    }
  ]
};
//行业一级下拉
const industry_type = {
  End: '终端',
  Manufacturer: '原厂',
  ServiceProvider: '服务商',
  Trade: '贸易',
  Broker: '代理'
};
//货运方式
const freightTypes = {
  arr: [
    {
      id: '100',
      name: '陆运'
    },
    {
      id: '200',
      name: '海运'
    },
    {
      id: '300',
      name: '空运'
    }
  ],
  json: {
    '100': '陆运',
    '200': '海运',
    '300': '空运',
  }
};
const accountTypes = {
  arr: [
    { id: 'user', name: 'portal.yong-hu', fullName: 'portal.yong-hu-zhang-hu' },
    { id: 'shop', name: 'portal.yong-jin', fullName: 'portal.yong-jin-zhang-hu' },
    { id: 'business', name: 'portal.mao-li', fullName: 'portal.mao-li-zhang-hu' },
    { id: 'department', name: 'portal.department', fullName: 'portal.zhu-ti-zhang-hu' },
    { id: 'employee', name: 'portal.yuan-gong', fullName: 'portal.yuan-gong-zhang-hu' },
    { id: 'singlershop', name: 'portal.zhu-ce', fullName: 'portal.zhu-ce' }
  ],
  json: {
    user: 'portal.yong-hu',
    shop: 'portal.yong-jin',
    business: 'portal.mao-li',
    department: 'portal.department',
    employee: 'portal.yuan-gong',
    singleshop: 'portal.zhu-ce'
  }
};

const accountDisplayType = {
  arr: [
    { id: '', name: '', fullName: '' },
    { id: 'own', name: '自有库存', fullName: '自有库存' },
    { id: 'agent', name: '原厂专卖', fullName: '原厂专卖' },
    { id: 'you', name: '合作库存', fullName: '合作库存' }
  ]
};
const bankApproval = {
  arr: [
    { id: 'draft', name: '初' },
    { id: 'submit', name: '提' },
    { id: 'return', name: '退' },
    { id: 'cancel', name: '撤' },
    { id: 'confirm', name: '准' }
  ],
  json: {
    draft: '初',
    submit: '提',
    return: '退',
    cancel: '撤',
    confirm: '准'
  }
};
const brandTypes = {
  arr: [
    { id: '原厂', name: '原厂' },
    { id: '代理', name: '代理' },
    { id: '贸易', name: '贸易' },
    { id: '终端', name: '终端' }
  ],
  json: {
    原厂: '原厂',
    代理: '代理',
    贸易: '贸易',
    终端: '终端'
  }
};
const contactInTypes = {
  arr: [
    { id: 'account', name: '账户' },
    { id: 'partnered', name: '代表' },
    { id: 'lead', name: '线索' }
  ],
  json: {
    account: '账户',
    partnered: '代表',
    lead: '线索'
  },
  type: [
    { id: 'shop', name: '商户' },
    { id: 'shop_member', name: '成员' },
    { id: 'contact', name: '业务' },
    { id: 'shop_member_platform', name: '平台' },
    { id: 'guest', name: '访客' },
  ],
  typeJson: {
    'shop':'商户',
    'shop_member':'成员',
    'contact':'业务',
    'shop_member_platform':'业务',
    'guest':'访客',
  },
  typeLv1:  [
    { id: 'shop', name: '商户' },
    { id: 'shop_member', name: '成员' },
    { id: 'contact', name: '业务' },
    { id: 'guest', name: '访客' },
  ],
  sort: [
    { id: 'account', name: '单身' },
    { id: 'partnered', name: '圈子' },
    { id: 'lead', name: '合伙人' },
    { id: 'job', name: '职位' },
    { id: 'person', name: '个人' },
    { id: 'company', name: '公司' }
  ]
};
// 税号关系人
const taxNumbertype = {
  arr: [
    { id: '自然人', name: '自然人' },
    { id: '法人', name: '法人' }
  ],
  json: {
    自然人: '账户',
    法人: '代表'
  }
};
//业务类型
const bizType = {
  all: [
    { id: '', name: 'ALL' },
    { id: 'purchase_order', name: '采购' },
    { id: 'purchase_order_refund', name: '退购' },
    { id: 'sales_order', name: '销售' },
    { id: 'sales_order_refund', name: '退销' },
    { id: 'platform_purchase_order', name: '平台买入' },
    { id: 'platform_sales_order', name: '平台卖出' },
    { id: 'platform_purchase_order_refund', name: '平台退买' },
    { id: 'platform_sales_order_refund', name: '平台退卖' },
    { id: 'self_purchase_order', name: '内联买入' },
    { id: 'self_sales_order', name: '内联卖出' },
    { id: 'self_purchase_order_refund', name: '内联退买' },
    { id: 'self_sales_order_refund', name: '内联退卖' },
    { id: 'service', name: '服务' },
  ],
  payable: [
    { id: '', name: 'ALL' },
    { id: 'purchase_order', name: '采购' },
    { id: 'purchase_order_refund', name: '退购' },
    { id: 'platform_purchase_order', name: '平台买入' },
    //{ id: 'platform_sales_order', name: '平台卖出' },
    { id: 'platform_purchase_order_refund', name: '平台退买' },
    //{ id: 'platform_sales_order_refund', name: '平台退卖' },
    { id: 'self_purchase_order', name: '内联买入' },
    //{ id: 'self_sales_order', name: '内联卖出' },
    { id: 'self_purchase_order_refund', name: '内联退买' },
    //{ id: 'self_sales_order_refund', name: '内联退卖' },
    { id: 'service', name: '服务' },
  ],
  receivable: [
    { id: '', name: 'ALL' },
    { id: 'sales_order', name: '销售' },
    { id: 'sales_order_refund', name: '退销' },
    //{ id: 'platform_purchase_order', name: '平台买入' },
    { id: 'platform_sales_order', name: '平台卖出' },
    //{ id: 'platform_purchase_order_refund', name: '平台退买' },
    { id: 'platform_sales_order_refund', name: '平台退卖' },
    //{ id: 'self_purchase_order', name: '内联买入' },
    { id: 'self_sales_order', name: '内联卖出' },
    //{ id: 'self_purchase_order_refund', name: '内联退买' },
    { id: 'self_sales_order_refund', name: '内联退卖' },
    { id: 'service', name: '服务' },
  ],
  title_move: [
    {id:"payin_req",name:"收请款"},
    {id:"payin_advance",name:"收预支"},
    {id:"order_payout",name:"订单付费"},
    {id:"payin",name:"成交收款"},
    {id:"payout",name:"付货款"},
    {id:"send_out",name:"发货"},
    {id:"send_in",name:"收货"},
    {id:"write_off",name:"冲销"},
    {id:"pay_in_service",name:"收费"},
    {id:"pay_out_service",name:"付费"},
    {id:"repayment_principal",name:"还预支"},
    {id:"repayment_Interest",name:"付滞纳金"},
    {id:"pay_refund_ps",name:"退卖收款"},
    {id:"deal_pay",name: "成交付款"},
    {id:"offline_inbound_refund",name:"线下退收"},
    {id:"self_inbound_refund",name:"自营退收"},
    {id:"platform_inbound_refund",name:"担保退收"},
    {id:"payment_in",name:"收货款"}
  ],
  order_type_json: {
    self: '内联',
    platform: '平台',
    external: '外联'
  },
  //0 外联  1 平台  2内联
  orderLineType: {
    1: 'platform',
    2: 'self-operated',
  }
};
//开票方式
const taxCatge = {
  arr: [
    { id: 'electronic', name: '电子发票 ' },
    { id: 'paper', name: '纸质发票' }
  ],
  json: {
    electronic: '电子发票 ',
    paper: '纸质发票'
  }
};
//钱包充值申请类型
const walletType = {
  arr: [
    {
      id: 'recharge',
      name: 'portal.chong-zhi'
    },
    {
      id: 'withdrawal',
      name: 'portal.ti-xian'
    },
    {
      id: 'transfer',
      name: 'portal.zhuan-zhang'
    },
    {
      id: 'settlement',
      name: 'portal.jie-suan'
    },
    {
      id: 'payment',
      name: 'portal.zhi-fu'
    },
    {
      id: 'loan',
      name: 'portal.yu-zhi'
    },
    {
      id: 'refund',
      name: 'portal.tui-kuan'
    },
    {
      id: 'issue',
      name: 'portal.fa-xing'
    },
    {
      id: 'destruction',
      name: 'portal.xiao-hui'
    },
    // { id: 'repayment', name: '还款' },
    { id: 'lock', name: 'portal.dong-jie' },
    { id: 'unlock', name: 'portal.jie-dong' },
    { id: 'allocate', name: 'portal.tiao-bo' },
    { id: 'repaymentCapital', name: 'portal.hai-kuan'},
    { id: 'repaymentInterest', name: 'portal.fu-xi'},
    { id: 'creditRestoration', name: 'portal.xin-yong-hui-fu'},
    { id: 'creditLimitIncrease', name: 'portal.e-du-zeng-jia'},
    { id: 'creditLimitRecovery', name: 'portal.e-du-hui-shou'},
  ],
  json: {
    recharge: 'portal.chong-zhi',
    withdrawal: 'portal.ti-xian',
    transfer: 'portal.zhuan-zhang',
    settlement: 'portal.jie-suan',
    payment: 'portal.zhi-fu',
    loan: 'portal.yu-zhi',
    refund: 'portal.tui-kuan',
    // issue: '发行',
    destruction: 'portal.xiao-hui',
    repayment: 'portal.huan-kuan',
    lock:'portal.dong-jie',
    unlock:'portal.jie-dong',
    allocate:'portal.diao-bo',
    repaymentCapital: 'portal.huan-kuan',
    repaymentInterest: 'portal.fu-xi',
    creditRestoration: 'portal.xin-yong-hui-fu',
    creditLimitIncrease: 'portal.e-du-zeng-jia',
    creditLimitRecovery: 'portal.e-du-hui-shou',
  },

};
const priceTable = {
  arr: [
    { id: '0', name: '目录' },
    { id: '1', name: '参考' },
    { id: '2', name: '货源' }
  ],
  json: {
    '0': '目录 ',
    '1': '参考',
    '2': '货源',
  }
};
const panwei = {
  arr: [
    { id: '2', name: '目录' },
    { id: '3', name: '标准' },
    { id: '1', name: '非标' }
  ],
  json: {
    '2': '目录 ',
    '3': '标准',
    '1': '非标',
  }
};
const cartTypes = {
  json:{
    'P': 'portal.chu-shi',
    'S': 'portal.ti-jiao',
    'A': 'portal.pi-zhun',
    'R': 'portal.tui-hui',
    'C': 'portal.che-xiao',
    'M': 'portal.bian-geng',
  },
  arr: [
    {id:'P',name: 'portal.chu-shi'},
    {id:'S',name: 'portal.ti-jiao'},
    {id:'A',name: 'portal.pi-zhun'},
    {id:'R',name: 'portal.tui-hui'},
    {id:'C',name: 'portal.che-xiao'},
    {id:'M',name: 'portal.bian-geng'},
  ]
}
const qaLineType = {
  arr: [
    { id: 'rfq_line', name: 'portal.xun-pan'},
    { id: 'avab_line', name: 'portal.gong-pan'},
    { id: 'sales_order_line', name: 'portal.buy-pan'},
    { id: 'purchase_order_line', name: 'portal.mai-pan'},
    { id: 'inactive_avab_line', name: 'portal.can-kao'},
    { id: 'avab_purchase', name: 'portal.mai-pan'}
  ],
  arr1: [
    { id: 'rfq_line', name: 'portal.xun-pan'},
    { id: 'avab_line', name: 'portal.gong-pan'},
    { id: 'sales_order_line', name: 'portal.buy-pan'},
    { id: 'purchase_order_line', name: 'portal.mai-pan'},
    { id: 'inactive_avab_line', name: 'portal.can-kao'},
  ]
}
const matchTypeJson = {
  rfq_line:'portal.xun-jia',
  qfr_line:'portal.bao-jia',
  avab_line:'portal.gong-huo',
  qfa_line:'portal.xun-gong',
  sales_order_line:'portal.xiao-shou',
  purchase_order_line:'portal.cai-gou',
  avab_purchase:'portal.mai-pan'
}
const matchPublishTypeJson = {
  rfq_line:'portal.xun-pan',
  qfr_line:'portal.bao-jia',
  avab_line:'portal.gong-pan',
  qfa_line:'portal.xun-gong',
  sales_order_line:'portal.buy-pan',
  purchase_order_line:'portal.mai-pan',
  avab_purchase:'portal.mai-pan'
}
const matchPublishTypeArr = [
  { id: 'rfq_line', name: 'portal.xun-pan'},
  { id: 'qfr_line', name:'portal.bao-jia'},
  { id: 'avab_line', name:'portal.gong-pan'},
  { id: 'qfa_line', name:'portal.xun-gong'},
  { id: 'sales_order_line', name:'portal.buy-pan'},
  { id: 'purchase_order_line', name:'portal.mai-pan'},
  { id: 'avab_purchase', name:'portal.mai-pan'}
]
const matchPublishTypeArrFilter = [
  { id: 'rfq_line', name: 'portal.rfq'},
  { id: 'qfr_line', name:'portal.bao-jia'},
  { id: 'avab_line', name:'portal.avab'},
  { id: 'qfa_line', name:'portal.xun-gong'},
  { id: 'sales_order_line', name:'portal.mai'},
  { id: 'purchase_order_line', name:'portal.sell'},
  { id: 'inactive_avab_line', name:'portal.can-kao'},
  { id: 'avab_purchase', name:'portal.sell'}
]
const freeShipping = {
  arr: [
    {id: "portal.shi",name:"portal.shi"},
    {id: "portal.fou",name:"portal.fou"},
  ]
}
// 业务类型
const business_types = {
  arr: [
    {id: 'Avab', name: '供货'},
    {id: 'Rfq', name: '询价'},
    {id: 'purchase_order', name: '采购跟单'},
  ]
}
const account_contract_types = {
  arr: [
    {id: 1, name: '平台'},
    {id: 2, name: '内联'},
    {id: 3, name: '外联'},
  ],
  json:{
    1: '平台',
    2: '内联',
    3: '外联',
  }
}
const visitPageTypes = [
  {id:'list',name:'列表'},
  {id:'detail',name:'详情'},
  {id:'display',name:'展示页'},
]
const obtypes = [
  {id:'MEDIA',name:'媒体'},
  {id:'SHOP_SPU',name:'商品'},
  {id:'CATEG',name:'类目'},
  {id:'BRAND',name:'厂牌'},
  {id:'SPU',name:'品项'},
  {id:'VIEW',name:'视图'},
  {id:'TEXT',name:'文稿'},
  {id:'ALL',name:'所有'},
  {id:'REGISTER',name:'注册'},
  {id:'LOGIN',name:'登录'},
  {id:'CMS',name:'内容'},
]
const trackDefaults = {
  '/': { menu: '媒体', object_type: 'MEDIA' },
  '/portal/home': { menu: '媒体', object_type: 'MEDIA' },
  '/portal/sku': { menu: '商品', object_type: 'SHOP_SPU' },
  '/portal/category': { menu: '类目', object_type: 'CATEG' },
  '/portal/brand': {menu: '厂牌',object_type: 'BRAND'},
  '/portal/spu': { menu: '品项', object_type: 'SPU' },
  '/portal/image': { menu: '视图', object_type: 'VIEW' },
  '/portal/post': { menu: '文稿', object_type: 'TEXT' },
  '/portal/all': { menu: '所有', object_type: 'ALL' },
  '/register': { menu: '注册', object_type: 'REGISTER' },
  '/login': { menu: '登录', object_type: 'LOGIN' },
  '/srvContent/view': { menu: '', object_type: 'CMS' },
};
//subNav 导航 根据路由判定
const prefix = 'content';
const subNavGuide = {
  _title: {
    "nav.biz": [
      { name: "portal.cai-xiao-gong-zuo-tai", path: "/work-board" },
      // { name: '商品分类',disabled: true},
      // 供求项/询供项/询供单合并为下拉分组：缺省显示供求项，hover 展开子面板（询供项/询供单）
      { name: 'portal.gong-qiu-xiang', path: '/buy/biz_line', children: [
        { name: 'portal.xun-gong-xiang', path: '/sell/qfa_line' },
        { name: 'portal.xun-gong-dan', path: '/sell/qfa_list' }
      ] },
      { name: 'portal.xun-jia-xiang', path: '/buy/rfq_line' },
      { name: 'portal.xun-jia-dan', path: '/buy/rfq_list' },
      { name: 'portal.bao-jia-xiang', path: '/buy/qfr_line' },
      { name: 'portal.bao-jia-dan', path: '/buy/qfr_list' },
      { name: 'portal.xiao-shou-xiang', path: '/buy/sales_order_line' },
      { name: '匹配定价', path: '/buy/sales_match_line' },
      { name: 'portal.xiao-shou-dan', path: '/buy/sales_order_list' },
      //{ name: '买家', path: '/buy/buyer' }
      { name: 'portal.gong-huo-xiang', path: '/sell/avab_line' },
      { name: 'portal.gong-huo-dan', path: '/sell/avab_list' },
      { name: 'portal.cai-gou-gong-zuo-tai', path: '/buy/purchasing_rfq_line' },
      { name: 'portal.guan-li-xun-jia-lie-biao', path: '/buy/management_rfq_line' },
      { name: 'portal.cai-gou-xiang', path: '/sell/purchase_order_line' },
      { name: 'portal.cai-gou-dan', path: '/sell/purchase_order_list' },
      { name: 'portal.xia-dan-ren', path: '/buy/business_link' },
      { name: 'portal.zhi-neng-cha-xun', path: '/buy/smart_query' },
      // 退项管理入口（return_doc ）
      { name: 'returnDoc.menuTitle', path: '/return/return_request_line', pathArray: ['/store/return/return_request_detail'] }
    ],
    "nav.cart": [
      // { name: '工作台', path: '/cart/workb' },
      { name: '买卖单', path: '/cart/business_desk' },
      { name: '业务项', path: '/cart/biz_line' },
      { name: 'portal.mai-mai-che', path: '/cart/business_desk' },
      // { name: '买卖车', path: '/cart/buy_sell' },//买卖车购销台合并，原买卖车隐藏
      { name: 'portal.dui-zhang-dan', path: '/cart/checkout_account' },
      // { name: '交割单', path: '/cart/delivery_order' },
      { name: 'portal.dian-fu-dan', path: '/cart/advance_order' },
      { name: 'portal.gen-zong-tai', path: '/cart/order_trail' },
      { name: 'portal.pi-pei-lan', path: '/cart/workbench' },
      { name: '买卖项', path: '/cart/business_desk_line' },
      { name: '挂盘项', path: '/cart/sku' },
      { name: '产品', path: '/cart/product' },
      { name: '价格表', path: '/cart/price' },
      { name: '业务单', path: '/cart/biz_bill' },
    ],
    "portal.gong-zuo-tai": [{ name: 'portal.gong-zuo-tai', path: '/cart/workbench' }],
    "portal.wo-de": [
      { name: 'portal.ye-ji', path: '/member/dashboard' },
      { name: 'portal.xiang-qing', path: '/member/info' },
      { name: 'portal.zhang-hu', path: '/member/account' },
      { name: 'portal.lian-xi-ren', path: '/member/contact' },
      { name: 'portal.qian-bao', path: '/member/wallet' },
      { name: 'portal.shou-cang-shang-quan', path: '/member/collect_shop' },
      { name: 'portal.huo-ban-shang-quan', path: '/member/shop' },
      { name: 'portal.wen-jian', path: '/member/folder' },
      // { name: 'portal.tong-zhi', path: '/member/notification' },
      // { name: '活动', path: '/user/activity' },
      // { name: 'portal.yin-xiao', path: '/member/sound' }
    ],
    "portal.ren-mai": [
      { name: 'portal.lian-xi-ren', path: '/info/contact' }
      // {name: '关系', disabled: true},
      // {name: '关系类型', disabled: true},
    ],
    "nav.info": [
      { name: 'portal.dian-pu', path: '/info/profile' },
      { name: 'portal.xi-wei', path: '/info/member' },
      { name: 'portal.lian-xi-ren', path: '/info/contact' },
      { name: 'portal.zhang-hu', path: '/info/account' },
      { name: 'portal.zhi-wei', path: '/info/station' },
      { name: 'portal.shang-pin', path: '/cart/spu' },
      { name: 'portal.ku-cun-xiang', path: '/sell/sku' },
      { name: 'portal.pin-tuan', path: '/sell/grouping_buy' },
      { name: 'portal.huo-ban-shang-quan', path: '/info/partner_shop' },
      { name: 'portal.shou-cang-shang-quan', path: '/info/collect_shop' },
      { name: '企查查', path: '/info/qichacha' },
      { name: '推广', path: '/info/pushlist' },
      { name: '访问', path: '/info/visit'}
    ],
    "portal.gui-ze": [
      { name: 'portal.jia-ge', path: '/info/price_rule' }
    ],
    "nav.cms": [
      { name: 'portal.nei-kan', path: '/layout/inner', domain: 'content', authPath: `/${prefix}/layout/inner` },
      {
        name: 'portal.yuan-gao',
        path: '/work/creation',
        domain: 'content',
        authPath: `/${prefix}/work/creation`,
        suffix: {
          create: { name: 'portal.yuan-gao', path: '/work/createContent', suffix: 'create' },
          edit: { name: 'portal.yuan-gao', path: '/work/createContent', suffix: 'edit' },
          toAd: { name: 'portal.yuan-gao', path: '/work/createContent', suffix: 'toAd' },
          toInv: { name: 'portal.yuan-gao', path: '/work/createContent', suffix: 'toInv' }
        }
      },
      { name: 'portal.fa-bu-gao', path: '/editor/content', domain: 'content', authPath: `/${prefix}/editor/content` },
      {
        name: 'portal.lan-mu',
        path: '/editor/column',
        domain: 'content',
        authPath: `/${prefix}/editor/column`,
        suffix: {
          columnCreate: { name: 'portal.lan-mu', path: '/editor/createColumn', suffix: 'columnCreate' },
          columnEdit: { name: 'portal.lan-mu', path: '/editor/createColumn', suffix: 'columnEdit' }
        }
      },
      { name: 'portal.guang-gao-wei', path: '/advertisement/block', domain: 'content', authPath: `/${prefix}/advertisement/block` },
      { name: 'portal.guang-gao-gao', path: '/advertisement/adl', domain: 'content', authPath: `/${prefix}/advertisement/adl` },
      //{ name: '评论', path: '/work/comment', domain: 'content', authPath: `/${prefix}/work/comment` },
      { name: 'portal.yao-qing', path: '/interaction/invitation', domain: 'content', authPath: `/${prefix}/interaction/invitation` },
      { name: 'portal.wen-da', path: '/interaction/QA', domain: 'content', authPath: `/${prefix}/interaction/QA` },
      { name: 'portal.pian-hao', path: '/work/preference', domain: 'content', authPath: `/${prefix}/work/preference` },
      { name: 'portal.zhi-bo-shen-pi', path: '/work/liveAudit', domain: 'content', authPath: `/${prefix}/work/liveAudit` }
      // { name: '应答', path: '/work/answer', domain: 'content', authPath: `/${prefix}/work/answer` },
      // { name: '底部链接', path: '/editor/link', domain: 'content', authPath: '/erp/content/editor/link' },
      // { name: '规则', path: '/advertisement/policy', domain: 'content', authPath: `/${prefix}/advertisement/policy` },
      // { name: '关键词', path: '/interaction/keywords', domain: 'content', authPath: `/${prefix}/interaction/keywords` },
    ],
    "nav.order": [
      // { name: '买入车', path: '/order/buy_car' },
      // { name: '卖出车', path: '/order/sell_car' },
      // { name: '记账', path: '/order/payment_flow' },
      { name: 'portal.zhong-cai', path: '/order/arbitration' },
      { name: 'portal.xiao-shou-gen-dan', path: '/order/sale_bill' },
      { name: 'portal.xiao-shou-gen-xiang', path: '/order/sale_item' },
      { name: 'portal.xiao-shou-tui-huo', path: '/order/sale_return' },
      { name: 'portal.xiao-shou-fa-piao', path: '/finance/receivable/cfo_tax_receipt' },
      { name: 'portal.pei-song-dan', path: '/order/sale_deliver' },
      { name: 'portal.shou-kuan-dan', path: '/finance/receivable/cfo_payment' },
      //{ name: '销售发货', path: '/order/sale_shipping' },
      // { name: '客户下单人', path: '/order/customer_order' },
      { name: 'portal.cai-gou-gen-dan', path: '/order/purchase_bill' },
      { name: 'portal.cai-gou-gen-xiang', path: '/order/purchase_item' },
      { name: 'portal.cai-gou-tui-huo', path: '/order/purchase_return' },
      { name: 'portal.cai-gou-fa-piao', path: '/finance/payable/cfo_tax_receipt_outbound' },
      { name: 'portal.pei-shou-dan', path: '/order/purchase_receipts' },
      { name: 'portal.fu-kuan-dan', path: '/finance/payable/cfo_payment_outbound' },
      // { name: '供方下单人', path: '/order/provider_order' }
    ],
    "nav.setting": [
      { name: 'nav.setting', path: '/info/setting' },
      { name: 'portal.gui-ze', path: '/info/price_rule' },
      { name: 'portal.wen-jian-jia', path: '/info/folder' },
      { name: 'portal.yi-biao-pan', path: '/info/dashboard' },
      { name: 'portal.dao-ru', path: '/hub/upload', pathArray: ['/hub/upload', '/hub/match', '/hub/bom', '/hub/result'] },
      { name: 'portal.jie-kou', path: '/hub/api'},
      { name: 'portal.li-shi', path: '/hub/history' },
      { name: 'portal.tong-zhi', path: '/info/notification', type: 'notice'}
    ]
  },
  portal: {
    spu: {
      name: ['nav.home', 'nav.spu', '品项详情']
    },
    shop_spu: {
      name: ['nav.home', 'nav.info', 'nav.spu', '品项详情']
    },
    brand: {
      name: ['nav.home', 'nav.brand', '厂牌详情']
    },
    category: {
      name: ['nav.home', 'nav.category', '类目详情']
    },
    qa_line: {
      name: ['nav.home', 'nav.sku', '供求详情']
    },
    shop: {
      name: ['nav.home', 'nav.shop', '商圈详情']
    }
  },
  buy: {
    buyer: {
      name: ['nav.biz', '买家']
    },
    rfq_list: {
      name: ['nav.biz', 'portal.xun-jia-dan']
    },
    biz_line: {
      name: ['nav.biz', 'portal.gong-qiu-xiang']
    },
    rfq_line: {
      name: ['nav.biz', 'portal.xun-jia-xiang']
    },
    qfr_list: {
      name: ['nav.biz', 'portal.bao-jia-dan']
    },
    qfr_line: {
      name: ['nav.biz', 'portal.bao-jia-xiang']
    },
    sales_order_list: {
      name: ['nav.biz', 'portal.xiao-shou-dan']
    },
    sales_order_line: {
      name: ['nav.biz', 'portal.xiao-shou-xiang']
    },
    sales_match_line: {
      name: ['nav.biz', '匹配定价']
    },
    purchasing_rfq_line: {
      name: ['nav.biz', 'portal.cai-gou-gong-zuo-tai']
    },
    management_rfq_line: {
      name: ['nav.biz', 'portal.guan-li-xun-jia-lie-biao']
    },
    business_link: {
      name: ['nav.biz', 'portal.xia-dan-ren']
    }
  },
  //退货
  return: {
    return_request_line: {
      name: ['nav.biz', 'returnDoc.menuTitle']
    },
    return_request_detail: {
      name: ['nav.biz', 'returnDoc.menuTitle']
    }
  },
  cart: {
    workbench: {
      name: ['nav.cart', 'portal.pi-pei-lan']
    },
    spu: {
      name: ['nav.info', 'portal.shang-pin']
    },
    business_desk: {
      name: ['nav.cart', 'portal.mai-mai-che']
    },
    buy_sell: {
      name: ['nav.cart', 'portal.mai-mai-che']
    },
    checkout_account: {
      name: ['nav.cart', 'portal.dui-zhang-dan']
    },
    // delivery_order: {
    //   name: ['交易', '交割单']
    // },
    advance_order: {
      name: ['nav.cart', 'portal.dian-fu-dan']
    },
    order_trail: {
      name: ['nav.cart', 'portal.gen-zong-tai']
    },
    visit: {
      name: ['nav.cart', '访问']
    },
    business_desk_line: {
      name: ['nav.cart', '买卖项']
    },
    sku: {
      name: ['nav.cart', '挂盘项']
    },
    product: {
      name: ['nav.cart', '产品']
    }, 
    price: {
      name: ['nav.cart', '价格表']
    },
    biz_line:{
      name: ['nav.cart', '业务项']
    },
    biz_bill:{
      name: ['nav.cart', '业务单']
    }
  },
  sell: {
    seller: {
      name: ['nav.biz', 'portal.mai-jia']
    },
    avab_list: {
      name: ['nav.biz', 'portal.gong-huo-dan']
    },
    avab_line: {
      name: ['nav.biz', 'portal.gong-huo-xiang']
    },
    qfa_list: {
      name: ['nav.biz', 'portal.xun-gong-dan']
    },
    qfa_line: {
      name: ['nav.biz', 'portal.xun-gong-xiang']
    },
    sku: {
      name: ['nav.info', 'portal.ku-cun']
    },
    purchase_order_list: {
      name: ['nav.biz', 'portal.cai-gou-dan']
    },
    purchase_order_line: {
      name: ['nav.biz', 'portal.cai-gou-xiang']
    }
  },
  member: {
    dashboard: {
      name: ['portal.wo-de', 'portal.ye-ji']
    },
    account: {
      name: ['portal.wo-de', 'portal.zhang-hu']
    },
    contact: {
      name: ['portal.wo-de', 'portal.lian-xi-ren']
    },
    collect_shop: {
      name: ['portal.wo-de', 'portal.shou-cang-shang-quan']
    },
    folder: {
      name: ['portal.wo-de', 'portal.wen-jian']
    },
    notification: {
      name: ['portal.wo-de', 'portal.tong-zhi']
    },
    info: {
      name: ['portal.wo-de', 'portal.xiang-qing']
    },
    shop: {
      name: ['portal.wo-de', 'portal.huo-ban-shang-quan']
    },
    wallet: {
      name: ['portal.wo-de', 'portal.qian-bao']
    },
    sound: {
      name: ['portal.wo-de', 'portal.yin-xiao']
    },
  },
  hub: {
    upload: {
      name: ['nav.setting', 'portal.dao-ru']
    },
    bom: {
      name: ['nav.cart', 'portal.dao-ru']
    },
    match: {
      name: ['nav.cart', 'portal.dao-ru']
    },
    result: {
      name: ['nav.cart', 'portal.dao-ru']
    },
    history: {
      name: ['nav.setting', 'portal.li-shi']
    },
    api: {
      name: ['nav.setting', 'portal.jie-kou']
    }
  },
  info: {
    profile: {
      name: ['nav.info', 'portal.xiang-qing']
    },
    contact: {
      name: ['nav.info', 'portal.lian-xi-ren']
    },
    partner_shop: {
      name: ['nav.info', 'portal.huo-ban-shang-quan']
    },
    collect_shop: {
      name: ['nav.info', 'portal.shou-cang-shang-quan']
    },
    folder: {
      name: ['nav.setting', 'portal.wen-jian-jia']
    },
    account: {
      name: ['nav.info', 'portal.zhang-hu']
    },
    station: {
      name: ['nav.info', 'portal.zhi-wei']
    },
    member: {
      name: ['nav.info', 'portal.cheng-yuan']
    },
    dashboard: {
      name: ['nav.setting', 'portal.yi-biao-pan']
    },
    setting: {
      name: ['nav.setting', 'nav.setting']
    },
    price_rule: {
      name: ['nav.setting', 'portal.gui-ze']
    },
    notification: {
      name: ['nav.setting', 'portal.tong-zhi']
    },
    pushlist: {
      name: ['nav.info', '推广']
    },
    qichacha: {
      name: ['nav.info', '企查查']
    },
    visit:{
      name: ['nav.info', '访问']
    }
  },
  export: {
    totalName: ['portal.dao-chu', 'portal.dao-chu'],
    path: '/export/match'
  },
  mine: {
    create: {
      name: ['我的内容', '原稿']
    },
    subscribe: {
      name: ['我的内容', '订阅']
    },
    preference: {
      name: ['我的内容', '偏好']
    },
    answer: {
      name: ['我的内容', '应答']
    },
    comment: {
      name: ['我的内容', '评论']
    },
    invitation: {
      name: ['我的内容', '邀请']
    }
  },
  work: {
    creation: {
      name: ['nav.cms', 'portal.yuan-gao']
    },
    subscription: {
      name: ['nav.cms', '订阅']
    },
    preference: {
      name: ['nav.cms', 'portal.pian-hao']
    },
    liveAudit: {
      name: ['nav.cms', 'portal.zhi-bo-shen-pi']
    },
    answer: {
      name: ['nav.cms', '应答']
    },
    comment: {
      name: ['nav.cms', '评论']
    },
    invitation: {
      name: ['nav.cms', '邀请']
    },
    createContent: {
      name: ['nav.cms', '原稿']
    }
  },
  editor: {
    column: {
      name: ['nav.cms', '栏目']
    },
    content: {
      name: ['nav.cms', 'portal.fa-bu-gao']
    },
    link: {
      name: ['nav.cms', '底部链接']
    },
    createColumn: {
      name: ['nav.cms', '栏目']
    }
  },
  advertisement: {
    policy: {
      name: ['nav.cms', '规则']
    },
    block: {
      name: ['nav.cms', '广告位']
    },
    adl: {
      name: ['nav.cms', '广告项']
    }
  },
  interaction: {
    invitation: {
      name: ['nav.cms', '邀请']
    },
    QA: {
      name: ['nav.cms', '问答']
    }
  },
  layout: {
    inner: {
      name: ['nav.cms', 'portal.nei-kan']
    }
  },
  merchant: {
    column: {
      name: ['编辑管理', '栏目']
    },
    content: {
      name: ['编辑管理', '发布稿']
    },
    bottomLink: {
      name: ['编辑管理', '底部链接']
    },
    adKind: {
      name: ['广告管理', '规则']
    },
    adPost: {
      name: ['广告管理', '广告位']
    },
    adPro: {
      name: ['广告管理', '广告项']
    },
    invitation: {
      name: ['互动', '邀请']
    },
    questionnaire: {
      name: ['互动', '问答']
    }
  },
  order: {
    // buy_car: {
    //   name: ['订单', '买入车']
    // },
    // sell_car: {
    //   name: ['订单', '卖出车']
    // },
    // payment_flow: {
    //   name: ['订单', '记账']
    // },
    arbitration: {
      name: ['nav.order', 'portal.zhong-cai']
    },
    sale_bill: {
      name: ['nav.order', 'portal.xiao-shou-gen-dan']
    },
    sale_item: {
      name: ['nav.order', 'portal.xiao-shou-gen-xiang']
    },
    sale_return: {
      name: ['nav.order', 'portal.xiao-shou-tui-huo']
    },
    sale_tax_receipt: {
      name: ['nav.order', 'portal.xiao-shou-fa-piao']
    },
    sale_deliver: {
      name: ['nav.order', 'portal.pei-song-dan']
    },
    cfo_payment: {
      name: ['nav.order', 'portal.shou-kuan-dan']
    },
    // sale_shipping: {
    //   name: ['订单', '销售发货']
    // },
    customer_order: {
      name: ['nav.order', 'portal.ke-hu-xia-dan-ren']
    },
    purchase_bill: {
      name: ['nav.order', 'portal.cai-gou-gen-dan']
    },
    purchase_item: {
      name: ['nav.order', 'portal.cai-gou-gen-xiang']
    },
    purchase_return: {
      name: ['nav.order', 'portal.cai-gou-tui-huo']
    },
    purchase_tax_receipt: {
      name: ['nav.order', 'portal.cai-gou-fa-piao']
    },
    purchase_receipts: {
      name: ['nav.order', 'portal.pei-shou-dan']
    },
    cfo_payment_outbound: {
      name: ['nav.order', 'portal.fu-kuan-dan']
    },
    provider_order: {
      name: ['nav.order', 'portal.gong-fang-xia-dan-ren']
    }
  }
};
const navGuide = [
  {
    id: 'content',
    name: 'nav.cms',
    hiddenChildren: true,
    clickTo: { name: '详情', path: '/content/layout/inner', domain: 'content' },
    children: [
      {
        name: '我的内容',
        path: '/work/creation',
        domain: 'content'
      },
      {
        name: '编辑管理',
        path: '/editor/column',
        domain: 'content'
      },
      {
        name: '广告管理',
        path: '/advertisement/policy',
        domain: 'content'
      },
      {
        name: '互动',
        path: '/interaction/invitation',
        domain: 'content'
      }
    ]
  },
  {
    id: 'merchant',
    name: 'nav.info',
    hiddenChildren: true,
    clickTo: { name: '详情', path: '/store/info/profile' },
    children: [{ name: 'nav.info', path: '/store/info/profile' }]
  },
  {
    id: 'business',
    name: 'nav.biz',
    hiddenChildren: true,
    clickTo: { name: '供求项', path: '/store/buy/biz_line' },
    children: [
      {
        name: '商品',
        path: '/store/cart/spu'
      },
      {
        name: '需求',
        path: '/store/buy/biz_line'
      },
      {
        name: '供应',
        path: '/store/sell/avab_line'
      },
      {
        name: '导入',
        path: '/store/hub/upload'
      }
    ]
  },
  {
    id: 'cart',
    name: 'nav.cart',
    hiddenChildren: true,
    clickTo: { name: '详情', path: '/store/cart/business_desk' }
  },
  {
    id: 'order',
    name: 'nav.order',
    hiddenChildren: true,
    clickTo: { name: '销售跟单', path: '/store/order/sale_bill' }
  },
  {
    id: 'manage',
    name: 'nav.setting',
    hiddenChildren: true,
    clickTo: { name: '站点', path: '/store/info/setting' }
  },
  {
    id: 'goBack',
    name: 'nav.erp',
    hiddenChildren: true,
    clickTo: { name: '详情', path: '' }
  },
];
/**
 *  domain: 'content' 这是跳转不同项目的标记 没有默认就是store
 */
const navGuideErp = [
  {
    id: 'account',
    name: '账户',
    hiddenChildren: true, //账户改为平铺模式
    clickTo: { name: '主账户', path: '/erp/account/account/main' },
    children: [
      {
        name: '账户',
        path: '/erp/account/account/main'
      },
      {
        name: '银行',
        path: '/erp/account/bank/info'
      },
      {
        name: '开票',
        path: '/erp/account/invoice/info'
      },
      {
        name: '联系人',
        path: '/erp/account/contact/info'
      },
      {
        name: '协议',
        path: '/erp/account/agreement/version'
      }
    ]
  },
  {
    id: 'product',
    name: '产品',
    children: [
      // {
      //   name: '产品台',
      //   path: '/erp/product/workbench'
      // },
      // {
      //   name: '厂牌',
      //   path: '/erp/product/brand/management'
      // },
      // {
      //   name: '类目',
      //   path: '/erp/product/category/management'
      // },
      // {
      //   name: '品项',
      //   path: '/erp/product/spu/management'
      // },
      // {
      //   name: '参数',
      //   path: '/erp/product/attribute/attribute'
      // },
      // {
      //   name: '规格',
      //   path: '/erp/product/specification/info'
      // },
      // {
      //   name: '价格',
      //   path: '/erp/product/price/price_list'
      // },
      // {
      //   name: '合格供方',
      //   path: '/erp/product/spu_qualified_vendor/management'
      // },
      // {
      //   name: '审批',
      //   path: '/erp/product/name_sourcing/management'
      // },
      {
        name: '产品管理',
        path: '/erp/product/product/spu'
      },
      {
        name: '目录管理',
        path: '/erp/product/name_sourcing/management'
      }
    ]
  },
  {
    id: 'logistics',
    name: '物流',
    children: [
      {
        name: '分拣',
        path: '/erp/logistics/picking/receipt'
      },
      {
        name: '运输',
        path: '/erp/logistics/transport/waybill'
      },
      {
        name: '品检',
        path: '/erp/logistics/quality/qc_test'
      },
      {
        name: '库管',
        path: '/erp/logistics/store_keeper/stock_check'
      },
      {
        name: '仓储',
        path: '/erp/logistics/warehousing/stock'
      },
      {
        name: '库区',
        path: '/erp/logistics/reservoir_area/warehouse'
      },
      {
        name: '管理',
        path: '/erp/logistics/management/tenement'
      }
    ]
  },
  {
    id: 'finance',
    name: '财务',
    children: [
      {
        name: '应收',
        path: '/erp/finance/receivable/cfo_invoice'
      },
      {
        name: '应付',
        path: '/erp/finance/payable/cfo_invoice_outbound'
      },
      {
        name: '账务',
        path: '/erp/finance/account/cfo_invoice'
      },
      {
        name: '科目',
        path: '/erp/finance/title/cfo_title'
      },
      {
        name: '结算',
        path: '/erp/finance/statement/cfo_statement'
      }
    ]
  },
  {
    id: 'service',
    name: '数据',
    children: [
      {
        name: '基础配置',
        path: '/erp/service/indexer/dictionary'
      },
      {
        name: '报表',
        path: '/erp/service/reporting/metrics'
      },
      {
        name: '活动',
        path: '/erp/service/activity'
      },
      {
        name: '映射',
        path: '/erp/service/mapping/interchange'
      },
      {
        name: '字段映射',
        path: '/erp/service/list_mapping/column'
      },
      {
        name: '模板管理',
        path: '/erp/service/manage/print'
      },
      {
        name: '引擎',
        path: '/erp/service/engine/policy'
      },
    ]
  },
  {
    id: 'portal',
    name: '营运',
    children: [
      {
        name: '授权',
        path: '/erp/portal/grant/position'
      },
      {
        name: '组织',
        path: '/erp/portal/organization/sbu'
      }
    ]
  },
  {
    id: 'contract',
    name: '合约',
    children: [
      { name: '芯之元', path: '/erp/origin/bank', domain: 'contract' },
      { name: '资源配额', path: '/erp/resource/quota', domain: 'contract' },
      { name: '任务激励', path: '/erp/encourage/level', domain: 'contract' },
      { name: '合约管理', path: '/erp/manage/combo', domain: 'contract' },
      { name: '签约管理', path: '/erp/hubs/sign', domain: 'contract' }
    ]
  }
];
const subNavGuideErp = {
  _title: {
    账户: [
      { name: '主账户', path: '/erp/account/account/main' },
      { name: '账户管理', path: '/erp/account/account/management' },
      // { name: '账户信息', path: '/erp/account/account/info' },
      //   { name: '账户财务', path: '/erp/account/account/finance' },
      { name: '买家信息', path: '/erp/account/account/buyer' },
      { name: '供方信息', path: '/erp/account/account/seller' },
      // { name: '佣金账户', path: '/erp/account/account/shop' },
      // { name: '积分账户', path: '/erp/account/account/user' },
      { name: '账户银行', path: '/erp/account/bank/info' },
      { name: '银行户头', path: '/erp/account/bank/bank_account' },
      { name: '银行', path: '/erp/account/bank/bank' },
      { name: '账户开票', path: '/erp/account/invoice/info' },
      { name: '税号', path: '/erp/account/invoice/tax' },
      { name: '联系人', path: '/erp/account/contact/info' },
      { name: '回收车', path: '/erp/account/account/recycle' },
      { name: '预约', path: '/erp/account/account/appointment' },
      { name: '商事主体', path: '/erp/account/account/legal_entity' },
    ],
    银行: [
      { name: '账户银行', path: '/erp/account/bank/info' },
      { name: '银行户头', path: '/erp/account/bank/bank_account' },
      { name: '银行', path: '/erp/account/bank/bank' }
    ],
    开票: [
      { name: '账户开票', path: '/erp/account/invoice/info' },
      { name: '税号', path: '/erp/account/invoice/tax' }
    ],
    联系人: [
      { name: '联系人', path: '/erp/account/contact/info' }
      // { name: '下单人', path: '/erp/account/contact/member' }
    ],
    协议: [{ name: '协议版本', path: '/erp/account/agreement/version' }],
    产品台: [{ name: '产品台', path: '/erp/product/workbench' }],
    厂牌: [
      { name: '厂牌管理', path: '/erp/product/brand/management' },
      { name: '厂牌信息', path: '/erp/product/brand/info' },
      { name: '业务报表', path: '/erp/product/brand/business_report' },
      { name: '信息报表', path: '/erp/product/brand/info_report' }
    ],
    类目: [
      { name: '类目管理', path: '/erp/product/category/management' },
      { name: '类目信息', path: '/erp/product/category/info' },
      { name: '业务报表', path: '/erp/product/category/business_report' }
    ],
    品项: [
      { name: '品项管理', path: '/erp/product/spu/management' },
      { name: '品项信息', path: '/erp/product/spu/info' },
      { name: '业务报表', path: '/erp/product/spu/business_report' },
      { name: '信息报表', path: '/erp/product/spu/info_report' }
    ],
    参数: [
      { name: '参数项', path: '/erp/product/attribute/attribute' },
      { name: 'ECCN', path: '/erp/product/attribute/eccn' },
      { name: 'HSCode', path: '/erp/product/attribute/hscode' },
      { name: '封装', path: '/erp/product/attribute/package' }
    ],
    规格: [
      { name: '规格项', path: '/erp/product/specification/info' },
      { name: '规格明细', path: '/erp/product/specification/detail' }
    ],
    价格: [
      { name: '价格表', path: '/erp/product/price/price_list' },
      { name: '目录项', path: '/erp/product/price/list_price' },
      { name: '政策', path: '/erp/product/price/policy' },
      { name: '政策规则', path: '/erp/product/price/price_rule' }
    ],
    合格供方: [
      { name: '合格供方列表', path: '/erp/product/spu_qualified_vendor/management' },
      { name: '合格关系（厂牌）', path: '/erp/product/spu_qualified_vendor/brandlist' },
      { name: '合格关系（业务项）', path: '/erp/product/spu_qualified_vendor/shopspu' }
    ],
    审批: [{ name: '审批', path: '/erp/product/name_sourcing/management' }],
    分拣: [
      { name: '收货单', path: '/erp/logistics/picking/receipt' },
      { name: '收货项', path: '/erp/logistics/picking/receipt_line' },
      { name: '入库单', path: '/erp/logistics/picking/put_in_storage' },
      { name: '入库项', path: '/erp/logistics/picking/put_in_storage_line' },
      { name: '出库单', path: '/erp/logistics/picking/ex_warehouse' },
      { name: '出库项', path: '/erp/logistics/picking/ex_warehouse_line' },
      { name: '发货单', path: '/erp/logistics/picking/shipments' },
      { name: '发货项', path: '/erp/logistics/picking/shipments_line' },
      { name: '母单', path: '/erp/logistics/picking/order' },
      { name: '母单项', path: '/erp/logistics/picking/order_line' },
      { name: '服务项', path: '/erp/logistics/picking/service_line' }
    ],
    运输: [
      { name: '运单', path: '/erp/logistics/transport/waybill' },
      // { name: '箱单', path: '/erp/logistics/transport/packing_list' },
      // { name: '箱单项', path: '/erp/logistics/transport/packing_item' },
      { name: '关单', path: '/erp/logistics/transport/tariff' },
      { name: '关单项', path: '/erp/logistics/transport/tariff_line' },
      { name: '承运商', path: '/erp/logistics/transport/carriers' },
      // { name: '货运方式', path: '/erp/logistics/transport/shipping_method' },
      // { name: '报关方式', path: '/erp/logistics/transport/tariff_filing' }
    ],
    品检: [
      { name: '品检项', path: '/erp/logistics/quality/qc_test' },
      // { name: '报告项', path: '/erp/logistics/quality/qc_report' },
      { name: '品检类型', path: '/erp/logistics/quality/qc_categ' },
      { name: '品检规则', path: '/erp/logistics/quality/qc_rule' }
      // { name: '规则样例', path: '/erp/logistics/quality/qc_sample' }
    ],
    库管: [
      { name: '盘点单', path: '/erp/logistics/store_keeper/stock_check' },
      { name: '盘点项', path: '/erp/logistics/store_keeper/stock_check_line' },
      { name: '调拨单', path: '/erp/logistics/store_keeper/moving' },
      { name: '调拨项', path: '/erp/logistics/store_keeper/moving_line' }
    ],
    仓储: [
      { name: '存货单', path: '/erp/logistics/warehousing/stock' },
      { name: '存货项', path: '/erp/logistics/warehousing/stock_line' },
      { name: '仓单', path: '/erp/logistics/warehousing/warehouse_receipt' },
      { name: '仓单项', path: '/erp/logistics/warehousing/warehouse_receipt_item' },
      { name: '排期', path: '/erp/logistics/warehousing/scheduling' },
      { name: '货箱', path: '/erp/logistics/warehousing/packing_box' },
      { name: '包装', path: '/erp/logistics/warehousing/packaging' }
    ],
    库区: [
      { name: '仓库', path: '/erp/logistics/reservoir_area/warehouse' },
      { name: '库区', path: '/erp/logistics/reservoir_area/section' },
      { name: '库位', path: '/erp/logistics/reservoir_area/lot' },
      { name: '跟踪号', path: '/erp/logistics/reservoir_area/tracking_no' },
      { name: '布局', path: '/erp/logistics/reservoir_area/layout' },
      { name: '通道', path: '/erp/logistics/reservoir_area/channel' },
      { name: '路线', path: '/erp/logistics/reservoir_area/path' },
      { name: '类型', path: '/erp/logistics/reservoir_area/type' }
    ],
    管理: [
      { name: '租户', path: '/erp/logistics/management/tenement' },
      { name: '关系户', path: '/erp/logistics/management/connected_group' },
      { name: '交易员', path: '/erp/logistics/management/traders' },
      { name: '联系人', path: '/erp/logistics/management/contacts' },
      { name: '工单', path: '/erp/logistics/management/work_order' },
      { name: '工单项', path: '/erp/logistics/management/work_order_item' },
      { name: '费用', path: '/erp/logistics/management/expense' },
      { name: '费用项', path: '/erp/logistics/management/expense_item' }
    ],
    员工: [{ name: '仪表盘', path: '/erp/staff/dashboard' }],
    基础配置: [
      { name: '字典', path: '/erp/service/indexer/dictionary' },
      { name: '索引', path: '/erp/service/indexer/indexer' },
      { name: '接口', path: '/erp/service/indexer/interface' },
      { name: '词库', path: '/erp/service/indexer/word' },
      { name: '服务实体', path: '/erp/service/indexer/entity' },
      { name: '服务字段', path: '/erp/service/indexer/field' },
      { name: '区域', path: '/erp/service/indexer/region' },
      { name: '币种', path: '/erp/service/currency' },
      { name: '税率', path: '/erp/service/tax' }
    ],
    报表: [
      { name: '指标', path: '/erp/service/reporting/metrics' },
      { name: '维度', path: '/erp/service/reporting/dimension' },
      { name: 'KPI', path: '/erp/service/reporting/kpi' },
      { name: '仪表盘', path: '/erp/service/reporting/dashboard' }
    ],
    活动: [{ name: '活动', path: '/erp/service/activity' }],
    映射: [
      { name: '交互对象', path: '/erp/service/mapping/interchange' },
      { name: '账户映射', path: '/erp/service/mapping/account' },
      { name: '监控日志', path: '/erp/service/mapping/monitor' }
    ],
    模板管理: [
      { name: '打印模板', path: '/erp/service/manage/print' },
      { name: '接口管理', path: '/erp/service/manage/api' },
      { name: '应用接入', path: '/erp/service/manage/access' },
      { name: '网站模板', path: '/erp/service/manage/site_template' },
      { name: '网站', path: '/erp/service/manage/site' },
      { name: '域名', path: '/erp/service/manage/domain' },
      { name: '菜单模板', path: '/erp/service/manage/menu_template' },
      { name: '字段映射', path: '/erp/service/list_mapping/column' },
      { name: '字段别名', path: '/erp/service/list_mapping/field' }
    ],
    引擎: [
      { name: '政策管理', path: '/erp/service/engine/policy' },
      { name: '规则管理', path: '/erp/service/engine/rule' }
    ],
    授权: [
      { name: '岗位表', path: '/erp/portal/grant/position' },
      { name: '权限表', path: '/erp/portal/grant/privilege' },
      { name: '默认职位', path: '/erp/portal/grant/default_station' }
    ],
    组织: [
      { name: '部门', path: '/erp/portal/organization/sbu' },
      { name: '职位', path: '/erp/portal/organization/job' },
      { name: '任职', path: '/erp/portal/organization/appoint' }
    ],
    芯之元: [
      { name: 'IC银行', path: '/erp/origin/bank', domain: 'contract', authPath: '/erp/contract/origin/bank' },
      { name: '账簿', path: '/erp/origin/card', domain: 'contract', authPath: '/erp/contract/origin/card' },
      { name: '记账', path: '/erp/origin/currency', domain: 'contract', authPath: '/erp/contract/origin/currency' },
      { name: '交易单', path: '/erp/origin/trade_apply', domain: 'contract', authPath: '/erp/contract/origin/trade_apply' },
      { name: '交易流水', path: '/erp/origin/trade_log', domain: 'contract', authPath: '/erp/contract/origin/trade_log' },
      { name: '预支', path: '/erp/origin/debt', domain: 'contract', authPath: '/erp/contract/origin/debt' }
    ],
    资源配额: [{ name: '配额项', path: '/erp/resource/quota', domain: 'contract', authPath: '/erp/contract/resource/quota' }],
    任务激励: [
      { name: '等级', path: '/erp/encourage/level', domain: 'contract', authPath: '/erp/contract/encourage/level' },
      { name: '任务', path: '/erp/encourage/task', domain: 'contract', authPath: '/erp/contract/encourage/task' },
      { name: '激励', path: '/erp/encourage/incentive', domain: 'contract', authPath: '/erp/contract/encourage/incentive' }
    ],
    合约管理: [
      { name: '套餐管理', path: '/erp/manage/combo', domain: 'contract', authPath: '/erp/contract/manage/combo' },
      { name: '合约模板', path: '/erp/manage/template', domain: 'contract', authPath: '/erp/contract/manage/template' }
    ],
    签约管理: [
      { name: '签约', path: '/erp/hubs/sign', domain: 'contract', authPath: '/erp/contract/hubs/sign' },
      { name: '签约配额', path: '/erp/hubs/quota', domain: 'contract', authPath: '/erp/contract/hubs/quota' },
      { name: '签约任务', path: '/erp/hubs/task', domain: 'contract', authPath: '/erp/contract/hubs/task' },
      { name: '签约激励', path: '/erp/hubs/incentive', domain: 'contract', authPath: '/erp/contract/hubs/incentive' }
    ],
    产品管理: [
      { name: '品项', path: '/erp/product/product/spu' },
      { name: '厂牌', path: '/erp/product/product/brand' },
      { name: '类目', path: '/erp/product/product/category' },
      { name: '参数项', path: '/erp/product/product/attribute' },
      { name: 'ECCN', path: '/erp/product/product/eccn' },
      { name: 'HSCode', path: '/erp/product/product/hscode' },
      { name: '封装', path: '/erp/product/product/package' },
      { name: '规格项', path: '/erp/product/product/fmt' },
      { name: '规格明细', path: '/erp/product/product/detail' },
      { name: '品项报表', path: '/erp/product/product/spu_report' },
      { name: '厂牌报表', path: '/erp/product/product/brand_report' },
      { name: '名称管理', path: '/erp/product/product/apl' }
    ],
    目录管理: [
      { name: '价格表', path: '/erp/product/price/price_list' },
      { name: '目录项', path: '/erp/product/price/list_price' },
      { name: '政策', path: '/erp/product/price/policy' },
      { name: '政策规则', path: '/erp/product/price/price_rule' },
      { name: '合格供方', path: '/erp/product/price/management' },
      { name: '合供厂牌', path: '/erp/product/price/brandlist' },
      { name: '合供品项', path: '/erp/product/price/shopspu' }
    ],
    应收: [
      { name: '应收账单', path: '/erp/finance/receivable/cfo_invoice'},
      { name: '应收账项', path: '/erp/finance/receivable/cfo_invoice_line'},
      { name: '收款单', path: '/erp/finance/receivable/cfo_payment'},
      { name: '核销项', path: '/erp/finance/receivable/cfo_write_off'},
      { name: '发票单', path: '/erp/finance/receivable/cfo_tax_receipt'},
      { name: '发票项', path: '/erp/finance/receivable/cfo_tax_receipt_line'},
      { name: '费用单', path: '/erp/finance/receivable/cfo_invoice_expense'},
      { name: '费用项', path: '/erp/finance/receivable/cfo_invoice_line_expense'},
      { name: '客户', path: '/erp/finance/receivable/customer'},
    ],
    应付: [
      { name: '应付账单', path: '/erp/finance/payable/cfo_invoice_outbound'},
      { name: '应付账项', path: '/erp/finance/payable/cfo_invoice_line_outbound'},
      { name: '付款单', path: '/erp/finance/payable/cfo_payment_outbound'},
      { name: '核销项', path: '/erp/finance/payable/cfo_write_off_outbound'},
      { name: '发票单', path: '/erp/finance/payable/cfo_tax_receipt_outbound'},
      { name: '发票项', path: '/erp/finance/payable/cfo_tax_receipt_line_outbound'},
      { name: '费用单', path: '/erp/finance/payable/cfo_invoice_outbound_expense'},
      { name: '费用项', path: '/erp/finance/payable/cfo_invoice_line_outbound_expense'},
      { name: '供应商', path: '/erp/finance/payable/vendor'},
    ],
    账务: [
      { name: '账本', path: '/erp/finance/account/cfo_invoice'},
      { name: '分录单', path: '/erp/finance/account/cfo_title_move'},
      { name: '分录项', path: '/erp/finance/account/cfo_title_move_line'},
      { name: '主体', path: '/erp/finance/account/cfo_card'},
      { name: '科目', path: '/erp/finance/account/cfo_title'},
    ],
    结算: [
      { name: '结算单', path: '/erp/finance/statement/cfo_statement'},
      { name: '结算核销项', path: '/erp/finance/statement/cfo_statement_write_off_rel'},
      { name: '结算费用项', path: '/erp/finance/statement/cfo_statement_invoice_line_rel'},
    ],
  },
  erp: {
    account: {
      account: {
        main: {
          name: ['账户', '主账户']
        },
        management: {
          name: ['账户', '账户管理']
        },
        info: {
          name: ['账户', '账户信息']
        },
        finance: {
          name: ['账户', '账户财务']
        },
        buyer: {
          name: ['账户', '买家信息']
        },
        seller: {
          name: ['账户', '供方信息']
        },
        shop: {
          name: ['账户', '佣金账户']
        },
        user: {
          name: ['账户', '积分账户']
        },
        recycle: {
          name: ['账户', '回收车']
        },
        appointment: {
          name: ['账户', '预约']
        },
        legal_entity:{
          name: ['账户', '商事主体']
        }
      },
      bank: {
        info: {
          name: ['账户', '账户银行']
        },
        bank_account: {
          name: ['账户', '银行户头']
        },
        bank: {
          name: ['账户', '银行']
        }
      },
      invoice: {
        info: {
          name: ['账户', '账户开票']
        },
        tax: {
          name: ['账户', '税号']
        }
      },
      contact: {
        info: {
          name: ['账户', '联系信息']
        },
        member: {
          name: ['账户', '成员信息']
        }
      },
      agreement: {
        version: {
          name: ['协议', '协议版本']
        }
      }
    },
    product: {
      workbench: {
        name: ['产品台', '产品台']
      },
      product: {
        spu: {
          name: ['产品管理', '品项']
        },
        brand: {
          name: ['产品管理', '厂牌']
        },
        category: {
          name: ['产品管理', '类目']
        },
        attribute: {
          name: ['产品管理', '参数项']
        },
        eccn: {
          name: ['产品管理', 'ECCN']
        },
        hscode: {
          name: ['产品管理', 'HSCode']
        },
        package: {
          name: ['产品管理', '封装']
        },
        fmt: {
          name: ['产品管理', '规格项']
        },
        detail: {
          name: ['产品管理', '规格明细']
        },
        spu_report: {
          name: ['产品管理', '品项报表']
        },
        brand_report: {
          name: ['产品管理', '厂牌报表']
        },
        apl: {
          name: ['产品管理', '名称管理']
        }
      },
      brand: {
        management: {
          name: ['厂牌', '厂牌管理']
        },
        info: {
          name: ['厂牌', '厂牌信息']
        },
        business_report: {
          name: ['厂牌', '业务报表']
        },
        info_report: {
          name: ['厂牌', '信息报表']
        }
      },
      category: {
        management: {
          name: ['类目', '类目管理']
        },
        info: {
          name: ['类目', '类目信息']
        },
        business_report: {
          name: ['类目', '业务报表']
        }
      },
      spu: {
        management: {
          name: ['品项', '品项管理']
        },
        info: {
          name: ['品项', '品项信息']
        },
        business_report: {
          name: ['品项', '业务报表']
        },
        info_report: {
          name: ['品项', '信息报表']
        }
      },
      attribute: {
        attribute: {
          name: ['参数', '参数项']
        },
        eccn: {
          name: ['参数', 'ECCN']
        },
        hscode: {
          name: ['参数', 'HSCode']
        },
        package: {
          name: ['参数', '封装']
        }
      },
      specification: {
        info: {
          name: ['规格', '规格项']
        },
        detail: {
          name: ['规格', '规格明细']
        }
      },
      price: {
        price_list: {
          name: ['目录管理', '价格表']
        },
        list_price: {
          name: ['目录管理', '目录项']
        },
        policy: {
          name: ['目录管理', '政策']
        },
        price_rule: {
          name: ['目录管理', '政策规则']
        },
        management: {
          name: ['目录管理', '合格供方列表']
        },
        brandlist: {
          name: ['目录管理', '合供厂牌']
        },
        shopspu: {
          name: ['目录管理', '合供品项']
        }
      },
      spu_qualified_vendor: {
        management: {
          name: ['合格供方', '合格供方列表']
        },
        brandlist: {
          name: ['合格供方', '合格关系（厂牌）']
        },
        shopspu: {
          name: ['合格供方', '合格关系（业务项）']
        }
      },
      name_sourcing: {
        management: {
          name: ['审批', '审批']
        }
      }
    },
    logistics: {
      picking: {
        receipt: {
          name: ['分拣', '收货单']
        },
        receipt_line: {
          name: ['分拣', '收货项']
        },
        put_in_storage: {
          name: ['分拣', '入库单']
        },
        put_in_storage_line: {
          name: ['分拣', '入库项']
        },
        ex_warehouse: {
          name: ['分拣', '出库单']
        },
        ex_warehouse_line: {
          name: ['分拣', '出库项']
        },
        shipments: {
          name: ['分拣', '发货单']
        },
        shipments_line: {
          name: ['分拣', '发货项']
        },
        order: {
          name: ['分拣', '母单']
        },
        order_line: {
          name: ['分拣', '母单项']
        },
        service_line: {
          name: ['分拣', '服务项']
        }
      },
      transport: {
        waybill: {
          name: ['运输', '运单']
        },
        packing_list: {
          name: ['运输', '箱单']
        },
        packing_item: {
          name: ['运输', '箱单项']
        },
        tariff: {
          name: ['运输', '关单']
        },
        tariff_line: {
          name: ['运输', '关单项']
        },
        carriers: {
          name: ['运输', '承运商']
        },
        shipping_method: {
          name: ['运输', '货运方式']
        },
        tariff_filing: {
          name: ['运输', '报关方式']
        }
      },
      quality: {
        qc_test: {
          name: ['品检', '品检项']
        },
        qc_report: {
          name: ['品检', '报告项']
        },
        qc_categ: {
          name: ['品检', '品检类型']
        },
        qc_rule: {
          name: ['品检', '品检规则']
        },
        qc_sample: {
          name: ['品检', '规则样例']
        }
      },
      store_keeper: {
        stock_check: {
          name: ['库管', '盘点单']
        },
        stock_check_line: {
          name: ['库管', '盘点项']
        },
        moving: {
          name: ['库管', '调拨单']
        },
        moving_line: {
          name: ['库管', '调拨项']
        }
      },
      warehousing: {
        stock: {
          name: ['仓储', '存货单']
        },
        stock_line: {
          name: ['仓储', '存货项']
        },
        warehouse_receipt: {
          name: ['仓储', '仓单']
        },
        warehouse_receipt_item: {
          name: ['仓储', '仓单项']
        },
        scheduling: {
          name: ['仓储', '排期']
        },
        packing_box: {
          name: ['仓储', '货箱']
        },
        packaging: {
          name: ['仓储', '包装']
        }
      },
      reservoir_area: {
        warehouse: {
          name: ['库区', '仓库']
        },
        section: {
          name: ['库区', '库区']
        },
        lot: {
          name: ['库区', '库位']
        },
        tracking_no: {
          name: ['库区', '跟踪号']
        },
        layout: {
          name: ['库区', '布局']
        },
        channel: {
          name: ['库区', '通道']
        },
        path: {
          name: ['库区', '路线']
        },
        type: {
          name: ['库区', '类型']
        }
      },
      management: {
        tenement: {
          name: ['管理', '租户']
        },
        connected_group: {
          name: ['管理', '关系户']
        },
        traders: {
          name: ['管理', '交易员']
        },
        contacts: {
          name: ['管理', '联系人']
        },
        work_order: {
          name: ['管理', '工单']
        },
        work_order_item: {
          name: ['管理', '工单项']
        },
        expense: {
          name: ['管理', '费用']
        },
        expense_item: {
          name: ['管理', '费用项']
        }
      }
    },
    service: {
      indexer: {
        dictionary: {
          name: ['基础配置', '字典']
        },
        indexer: {
          name: ['基础配置', '索引']
        },
        interface: {
          name: ['基础配置', '接口']
        },
        word: {
          name: ['基础配置', '词库']
        },
        entity: {
          name: ['基础配置', '服务实体']
        },
        field: {
          name: ['基础配置', '服务字段']
        },
        region: {
          name: ['基础配置', '区域']
        },
        currency: {
          name: ['基础配置', '币种']
        },
        tax: {
          name: ['基础配置', '税率']
        },
      },
      reporting: {
        metrics: {
          name: ['报表', '指标']
        },
        dimension: {
          name: ['报表', '维度']
        },
        kpi: {
          name: ['报表', 'KPI']
        },
        dashboard: {
          name: ['报表', '仪表盘']
        }
      },
      activity: {
        name: ['活动', '活动']
      },
      mapping: {
        interchange: {
          name: ['映射', '交互对象']
        },
        account: {
          name: ['映射', '账户映射']
        },
        monitor: {
          name: ['映射', '监控日志']
        }
      },
      manage: {
        print: {
          name: ['模板管理', '打印模板']
        },
        api: {
          name: ['模板管理', '接口管理']
        },
        access: {
          name: ['模板管理', '应用接入']
        },
        site_template: {
          name: ['模板管理', '网站模板']
        },
        site: {
          name: ['模板管理', '网站']
        },
        domain: {
          name: ['模板管理', '域名']
        },
        menu: {
          name: ['模板管理', '菜单模板']
        },
        column: {
          name: ['模板管理', '字段映射']
        },
        field: {
          name: ['模板管理', '标准字段']
        }
      },
      engine: {
        policy: {
          name: ['引擎', '政策管理']
        },
        rule: {
          name: ['引擎', '规则管理']
        }
      }
    },
    portal: {
      grant: {
        position: {
          name: ['授权', '岗位表']
        },
        privilege: {
          name: ['授权', '权限表']
        },
        default_station: {
          name: ['授权', '默认职位']
        }
      },
      organization: {
        sbu: {
          name: ['组织', '部门']
        },
        job: {
          name: ['组织', '职位']
        },
        appoint: {
          name: ['组织', '任职']
        }
      }
    },
    contract: {
      origin: {
        bank: {
          name: ['芯之元', 'IC银行']
        },
        currency: {
          name: ['芯之元', '记账']
        },
        card: {
          name: ['芯之元', '账簿']
        },
        trade_apply: {
          name: ['芯之元', '交易单']
        },
        trade_log: {
          name: ['芯之元', '交易流水']
        },
        debt: {
          name: ['芯之元', '预支']
        }
      },
      resource: {
        quota: {
          name: ['资源配额', '配额项']
        }
      },
      encourage: {
        level: {
          name: ['任务激励', '等级']
        },
        task: {
          name: ['任务激励', '任务']
        },
        incentive: {
          name: ['任务激励', '激励']
        }
      },
      manage: {
        combo: {
          name: ['合约管理', '套餐管理']
        },
        template: {
          name: ['合约管理', '合约模板']
        }
      },
      hubs: {
        sign: {
          name: ['签约管理', '签约']
        },
        quota: {
          name: ['签约管理', '签约配额']
        },
        task: {
          name: ['签约管理', '签约任务']
        },
        incentive: {
          name: ['签约管理', '签约激励']
        }
      }
    },
    staff: {
      dashboard: {
        name: ['员工', '仪表盘']
      }
    },
    finance: {
      payable: {
        vendor: {
          name: ['应付', '供应商']
        },
        cfo_invoice_outbound: {
          name: ['应付', '应付账单']
        },
        cfo_invoice_line_outbound: {
          name: ['应付', '应付账项']
        },
        cfo_payment_outbound: {
          name: ['应付', '付款单']
        },
        cfo_write_off_outbound: {
          name: ['应付', '核销项']
        },
        cfo_tax_receipt_outbound: {
          name: ['应付', '发票单']
        },
        cfo_tax_receipt_line_outbound: {
          name: ['应付', '发票项']
        },
        cfo_invoice_outbound_expense: {
          name: ['应付', '费用单']
        },
        cfo_invoice_line_outbound_expense: {
          name: ['应付', '费用项']
        },
      },
      receivable: {
        customer: {
          name: ['应收', '客户']
        },
        cfo_invoice: {
          name: ['应收', '应收账单']
        },
        cfo_invoice_line: {
          name: ['应收', '应收账项']
        },
        cfo_payment: {
          name: ['应收', '收款单']
        },
        cfo_write_off: {
          name: ['应收', '核销项']
        },
        cfo_tax_receipt: {
          name: ['应收', '发票单']
        },
        cfo_tax_receipt_line: {
          name: ['应收', '发票项']
        },
        cfo_invoice_expense: {
          name: ['应收', '费用单']
        },
        cfo_invoice_line_expense: {
          name: ['应收', '费用项']
        },
      },
      account: {
        cfo_invoice: {
          name: ['账务', '账本']
        },
        cfo_title_move: {
          name: ['账务', '分录单']
        },
        cfo_title_move_line: {
          name: ['账务', '分录项']
        },
        cfo_card: {
          name: ['账务', '主体']
        },
        cfo_title: {
          name: ['账务', '科目']
        },
      },
      statement: {
        cfo_statement: {
          name: ['结算', '结算单']
        },
        cfo_statement_write_off_rel: {
          name: ['结算', '结算核销项']
        },
        cfo_statement_invoice_line_rel: {
          name: ['结算', '结算费用项']
        },
      },
      /* title: {
        cfo_title: {
          name: ['科目', '科目']
        },
      } */
    }
  }
};
let auth = {};
const baseAuth = {
  content: {
    layout: {
      inner: { list: true }
    },
    interaction: {
      keywords: { list: true }
    }
  },
  home: {},
  profile: {
    export: true
  },
  spu: {
    read: true,
    list: true,
    spu_list: {
      list: true,
      read: true
    }
  },
  store:{
    hub: {
      bom: {
        list: true
      },
      upload: {
        list: true
      },
      result: {
        list: true
      },
      match: {
        list: true
      },
      history: {
        list: true
      },
      api: {
        list: true
      }
    },
    info: {
      setting: {},
      dashboard: {},
      notification: {},
      collect_shop: {
        list: true,
        read: true
      },
      account: {
        list: true,
        read: true
      }
    },
    member: {
      dashboard: {},
      notification: {
        list: true,
        read: true
      },
      info: {},
      shop: {},
      wallet: {},
      sound: {
        list: true,
        read: true
      },
      account: {
        list: true,
        read: true
      },
      contact: {
        list: true,
        read: true
      },
      collect_shop: {
        list: true,
        read: true
      },
      folder: {
        list: true,
        read: true
      }
    },
    buy: {
      biz_line: {
        list: true
      },
      sales_match_line: {
        list: true
      },
      purchasing_rfq_line: {
        list: true
      }
    },
    cart: {
      business_desk:{
        list: true,
        read: true,
        export: true
      },
      buy_sell: {
        list: true,
        read: true
      },
      checkout_account:{
        list: true,
        read: true,
        export: true
      },
      advance_order:{
        list: true,
        read: true,
        export: true
      },
      order_trail:{
        list: true,
        read: true
      }
    },
  },
  erp: {
    logistics: {
      picking: {},
      transport: {
        // waybill: {
        //   list: true,
        //   read: true
        // },
        packing_list: {
          list: true,
          read: true
        },
        packing_item: {
          list: true,
          read: true
        },
        // tariff: {
        //   list: true,
        //   read: true
        // },
        // tariff_line: {
        //   list: true,
        //   read: true
        // },
        carriers: {
          list: true,
          read: true
        },
        shipping_method: {
          list: true,
          read: true
        },
        tariff_filing: {
          list: true,
          read: true
        }
      },
      quality: {
        // qc_test: {
        //   list: true,
        //   read: true
        // },
        qc_report: {
          list: true,
          read: true
        },
        // qc_categ: {
        //   list: true,
        //   read: true
        // },
        // qc_rule: {
        //   list: true,
        //   read: true
        // },
        qc_sample: {
          list: true,
          read: true
        }
      }
      // warehousing: {
      //   stock: {
      //     list: true,
      //     read: true
      //   },
      //   stock_line: {
      //     list: true,
      //     read: true
      //   },
      //   warehouse_receipt: {
      //     list: true,
      //     read: true
      //   },
      //   warehouse_receipt_item: {
      //     list: true,
      //     read: true
      //   },
      //   scheduling: {
      //     list: true,
      //     read: true
      //   },
      //   packing_box: {
      //     list: true,
      //     read: true
      //   },
      //   packaging: {
      //     list: true,
      //     read: true
      //   }
      // },
      // reservoir_area: {
      //   warehouse: {
      //     list: true,
      //     read: true
      //   },
      //   section: {
      //     list: true,
      //     read: true
      //   },
      //   lot: {
      //     list: true,
      //     read: true
      //   },
      //   tracking_no: {
      //     list: true,
      //     read: true
      //   },
      //   layout: {
      //     list: true,
      //     read: true
      //   },
      //   channel: {
      //     list: true,
      //     read: true
      //   },
      //   path: {
      //     list: true,
      //     read: true
      //   },
      //   type: {
      //     list: true,
      //     read: true
      //   }
      // },
      // management: {
      //   tenement: {
      //     list: true,
      //     read: true
      //   },
      //   connected_group: {
      //     list: true,
      //     read: true
      //   },
      //   traders: {
      //     list: true,
      //     read: true
      //   },
      //   contacts: {
      //     list: true,
      //     read: true
      //   },
      //   work_order: {
      //     list: true,
      //     read: true
      //   },
      //   work_order_item: {
      //     list: true,
      //     read: true
      //   },
      //   expense: {
      //     list: true,
      //     read: true
      //   },
      //   expense_item: {
      //     list: true,
      //     read: true
      //   }
      // }
    },
    // 主账户入口展示
    account: {
      account: {
        main: {
          list: true,
          read: true
        },
      }
    },
    portal: {
      // user: {
      //   management: {
      //     list: true,
      //     read: true
      //   }
      // },
      grant: {
        // position: {
        //   list: true,
        //   read: true
        // },
        // privilege: {
        //   list: true
        // }
      }
    },
    service: {
      indexer: {
        interface: {
          list: true,
          add: true,
          edit: true,
          editField: true,
          editEntity: true,
          editParams: true
        },
        word: {
          list: true,
          add: true,
          delete: true
        }
      },
      manage: {
        access: {
          list: true,
          add: true,
          edit: true,
          delete: true
        },
        /* menu: {
          list: true
        },
        domain: {
          list: true,
          add: true,
          edit: true,
          delete: true
        },
        site_template: {
          list: true,
          add: true,
          edit: true,
          delete: true
        } */
      },
      engine: {
        policy: {
          list: true,
          add: true,
          edit: true,
          delete: true
        },
        rule: {
          list: true,
          add: true,
          edit: true,
          delete: true
        }
      }
    },
    staff: {
      dashboard: {
        read: true,
        list: true
      }
    },
    finance: {
       /*payable:{
        cfo_tax_receipt_outbound: {
          read: true,
          list: true
        },
        cfo_tax_receipt_line_outbound: {
          read: true,
          list: true
        },
        cfo_invoice_outbound_expense: {
          //read: true,
          list: true
        },
        cfo_invoice_line_outbound_expense: {
          //read: true,
          list: true
        },
      },
      receivable:{
        cfo_tax_receipt: {
          read: true,
          list: true
        },
        cfo_tax_receipt_line: {
          read: true,
          list: true
        },
        cfo_invoice_expense: {
          //read: true,
          list: true
        },
        cfo_invoice_line_expense: {
          //read: true,
          list: true
        },
      },
      account:{
        cfo_invoice: {
          read: true,
          list: true
        },
        cfo_card: {
          read: true,
          list: true
        },
        cfo_title_move: {
          read: true,
          list: true
        },
        cfo_title_move_line: {
          read: true,
          list: true
        },
        cfo_title: {
          read: true,
          list: true
        }
      },
      title:{
        cfo_title: {
          read: true,
          list: true
        }
      }
      statement:{
        cfo_statement: {
          read: true,
          list: true
        },
        cfo_statement_write_off_rel: {
          read: true,
          list: true
        },
        cfo_statement_invoice_line_rel: {
          read: true,
          list: true
        },
      } */
    },
  }
};
if (process.client) {
  let profile = storage.get('profile');
  if (profile && profile.is_partner) {
    deepAssign(baseAuth.store.info, { partner_shop: {} });
  }
  auth = profile ? deepAssign(baseAuth, profile.auth) : { ...baseAuth };
}
const getAuth = () => {
  let tmp = { ...baseAuth };
  if (process.client) {
    tmp = storage.get('profile') ? deepAssign(baseAuth, storage.get('profile').auth) : { ...baseAuth };
  }
  tmp.store.cart.business_desk_line = {list: true}
  tmp.store.cart.sku = {list: true}
  tmp.store.cart.product = {list: true}
  tmp.store.cart.price = {list: true}
  tmp.store.cart.biz_line = {list: true}
  tmp.store.cart.biz_bill = {list: true}
  tmp.store.buy.smart_query = {list: true} // 智能查询页菜单权限（Global 全量可见，前端硬编码先例同 cart 六路由）
  return tmp;
};
// 涉及权限的按钮-对应路由
const authRoute = {
  mchtInsertColumn: prefix + '/editor/column', // 商户-栏目主页
  mchtUpdateColumn: prefix + '/editor/column', // 商户-栏目主页
  mchtDeleteColumn: prefix + '/editor/column',
  mchtActiveColumn: prefix + '/editor/column',
  mchtInsertCont: prefix + '/editor/content', // 商户-内容创建
  mchtDispatchCont: prefix + '/editor/content', // 商户-内容分派
  mchtColDispatch: prefix + '/editor/content', // 发布稿-栏目分派
  mchtApprovalCont: prefix + '/editor/content', // 商户-
  mchtAuditCont: prefix + '/editor/content', // 审批
  mchtCirculateCont: prefix + '/editor/content', // 传阅
  mchtTopCont: prefix + '/editor/content', // 商户-
  mchtCancelTopCont: prefix + '/editor/content', // 商户-
  mchtRecommendCont: prefix + '/editor/content', // 商户-
  mchtCancelRecommendCont: prefix + '/editor/content', // 商户-
  mchtNoticeCont: prefix + '/editor/content', // 商户-
  mchtCancelNoticeCont: prefix + '/editor/content', // 商户-
  mchtOpenCont: prefix + '/editor/content', // 商户-
  mchtAdjustCont: '/erp/content/editor/content', // 商户-
  mchtPutupCont: prefix + '/editor/content', // 商户-
  mchtPutDownCont: prefix + '/editor/content', // 商户-
  mchtConversionAdCont: prefix + '/editor/content', // 商户-
  mchtConversionInvCont: prefix + '/editor/content', // 商户-
  mchtBoardCont: prefix + '/editor/content', // 商户-
  mchtPublicCont: prefix + '/editor/content', // 商户-
  mchtInsertAdKind: prefix + '/advertisement/policy', // 商户-
  mchtUpdateAdKind: prefix + '/advertisement/policy', //
  mchtDeleteAdKind: prefix + '/advertisement/policy',
  mchtUpdateAdPost: prefix + '/advertisement/block', // 商户-
  mchtExhibitAdPost: prefix + '/advertisement/block', //
  mchtDispatchAdPost: prefix + '/advertisement/block',
  mchtUpdateAdPro: prefix + '/advertisement/adl', // 商户-
  mchtExhibitAdPro: prefix + '/advertisement/adl', //
  mchtDispatchAdPro: prefix + '/advertisement/adl',
  mchtRepealAdPro: prefix + '/advertisement/adl', // 商户-
  mchtPauseAdPro: prefix + '/advertisement/adl', //
  mchtOpenAdPro: prefix + '/advertisement/adl',
  mchtAttendInfo: prefix + '/merchant/worksInfo', // 商户-
  mchtInsertInfo: prefix + '/merchant/worksInfo', // 商户-
  mchtDeleteInfo: prefix + '/merchant/worksInfo', // 商户-
  mchtScoreInfo: prefix + '/interaction/QA', // 商户-
  mchtCloseInfo: prefix + '/merchant/worksInfo', // 商户-
  mchtInsertKeyword: prefix + '/merchant/keywords', // 商户-关键词
  mchtUpdateKeyword: prefix + '/merchant/keywords', // 商户-关键词
  mchtDeleteKeyword: prefix + '/merchant/keywords',
  mchtInsertSensitiveWord: prefix + '/merchant/sensitiveWords', // 商户-敏感词
  mchtUpdateSensitiveWord: prefix + '/merchant/sensitiveWords', // 商户-敏感词
  mchtDeleteSensitiveWord: prefix + '/merchant/sensitiveWords',
  mchtCloseComplain: '/erp/content/merchant/complain', // 商户-投诉
  mchtInsertBlink: '/erp/content/editor/link', // 商户-底部链接
  mchtUpdateBlink: '/erp/content/editor/link', // 商户-底部链接
  mchtDeleteBlink: '/erp/content/editor/link',
  mchtActiveBlink: '/erp/content/editor/link',
  mchtWorksColumn: prefix + '/merchant/worksColumn', // 商户-栏目详情页
  mineCreate: prefix + '/work/creation', // 内容-创建内容页
  mineUpdate: prefix + '/work/creation', // 内容-修改
  mineDelete: prefix + '/work/creation', // 内容-删除
  mineConversionAd: prefix + '/work/creation', // 内容-转广告
  mineConversionInv: prefix + '/work/creation', // 内容-转邀请
  mineViewInvitation: prefix + '/mine/viewInvitation', // 内容-展示邀请页
  minePreviewInvitation: prefix + '/mine/previewInvitation', // 内容-预览邀请页
  mineWorksMore: prefix + '/work/creation', // 内容-更多列表页
  mineApproval: prefix + '/work/creation', // 原稿-发表
  mineReturn: prefix + '/work/creation', // 原稿-退回
  mineAgreePublish: prefix + '/work/creation', // 原稿-同意撤稿
  mineRejectPublish: prefix + '/work/creation', // 原稿-驳回撤稿
  mineDispatch: prefix + '/work/creation' // 原稿-分派
};
// 基础按钮表
const authButton = {
  insert: 'insert', // 创建-添加-新增
  update: 'update', // 编辑
  delete: 'delete', // 删除
  read: 'read', // 查看
  active: 'active', // 启用
  open: 'open', // 激活 公开
  close: 'close', // 归档 关闭
  dispatch: 'dispatch', // 分派
  approval: 'approval', // 审核/批准/审批
  top: 'top', // 置顶
  cancel_top: 'cancel_top', // 取消置顶
  recommend: 'recommend', // 推荐
  cancel_recommend: 'cancel_recommend',
  notice: 'notice', // 公告
  cancel_notice: 'cancel_notice',
  circulate: 'circulate', // 传阅
  audit: 'list', // 内容审批
  adjust: 'adjust', // 调整
  put_up: 'put_up', // 申请上架
  put_down: 'put_down', // 申请下架
  conversion_ad: 'conversion_ad',
  conversion_inv: 'conversion_inv',
  board: 'board', // 设为模板
  public: 'public', // 公开
  exhibit: 'exhibit', // 展出
  repeal: 'repeal', // 撤销
  pause: 'pause', // 暂停
  attend: 'attend', // 确认参会
  score: 'score', // 评分
  publish: 'publish', // 发布
  begin: 'begin', // 发起
  stop: 'stop', // 终止
  sign: 'sign', // 签约
  renewal: 'renewal', // 续约
  change: 'change', // 变更
  recharge: 'recharge', // 充值
  activity: 'activity', // 活动
  put_on: 'put_on', // 上架
  put_off: 'put_off', // 下架
  return: 'return', // 退回/拒绝
  agree_publish: 'agree_publish',
  reject_publish: 'reject_publish',
  buy: 'buy', // 买入
  sell: 'sell', // 卖出
  payment: 'payment', // 支付
  pre_sale_changes: 'pre_sale_changes', // 售前变更
  after_sale_changes: 'after_sale_changes', // 售后退货
  confirm: 'confirm', // 确认
  submit: 'submit', // 提交
  item_approval: 'item_approval', // 子项审批
  cancel: 'cancel', // 取消
  release: 'release', // 发行
  destroy: 'destroy', // 销毁
  export: 'export', // 导出
  transfer: 'transfer_accounts', // 转账
  storage: 'storage',// 入库
  refund: 'refund',// 退款
  delivery: 'delivery',//配送申请
};
//布局banner尺寸比例
const bannerSize = {
  0: [820, 320],
  1: [820, 320],
  2: [820, 320],
  3: [820, 320],
  4: [1200, 320],
  5: [1200, 320],
  6: [1200, 320],
  7: [820, 320],
  8: [820, 320],
  9: [820, 320],
  10: [1200, 320],
  11: [1200, 320],
  12: [1200, 320],
  13: [1200, 320],
  14: [626, 320]
};
//文章类型
const articleType = { 0: '', 100: 'portal.wen-zhang', 200: 'portal.wen-da', 300: 'portal.wen-juan', 400: 'nav.invitation', 500: 'portal.guang-gao', 700: 'portal.tu-su', 901: 'portal.shou-jian', 902: 'portal.fa-jian', 903: 'portal.zhi-bo' };
const sameAsPhy = ['10', '30', '40', '50' ];//和实物单相同逻辑的类型
const qcLevelOpts = [
  {id:'t1',name:'品控'},
  {id:'t2',name:'检测'},
]
export {
  ichubProjectList,
  ichubProjectData,
  qaType,
  ruleType,
  priceType,
  stateType,
  bizType,
  dataType,
  hostType,
  mappingType,
  interchangeType,
  approveType,
  orderBusinessStatus,
  auth,
  getAuth,
  baseAuth,
  registrationTypes,
  contactTypes,
  freightTypes,
  authRoute,
  authButton,
  bannerSize,
  articleType,
  accountTypes,
  accountDisplayType,
  contactInTypes,
  navGuide,
  subNavGuide,
  navGuideErp,
  subNavGuideErp,
  brandTypes,
  bankApproval,
  taxNumbertype,
  link_type,
  link_type_new,
  sales_types,
  stateTypeNew,
  industry_type,
  approveTypeEN,
  salesSource,
  taxCatge,
  link_contact,
  approvalLetter,
  invoice_term,
  address_type,
  walletType,
  busySome,
  busySome2,
  cartTypes,
  priceTable,
  qaLineType,
  orderTypeAndPan,
  panwei,
  matchPublishTypeJson,
  matchTypeJson,
  matchPublishTypeArr,
  matchPublishTypeArrFilter,
  payType,
  freeShipping,
  business_types,
  account_contract_types,
  agreementType,
  sameAsPhy,
  visitPageTypes,
  obtypes,
  trackDefaults,
  companyTypes,
  livingState,
  qcLevelOpts
};
